<template>
  <div ref="preview" class="preview-area">
    <!-- 左边 -->
    <div class="preview-left">
      <div class="preview-left-top">
        <Divider>左边面板</Divider>
        <div style="display: flex; align-items: center">
          <div style="margin-right: 10px">年份段:</div>
          <DatePicker type="year" :value="formItem.startYear" placeholder="开始年份" style="width: 120px" @on-change="getStartYear"></DatePicker>
          <span style="padding:0 5px">到</span>
          <DatePicker type="year" :value="formItem.endYear" placeholder="结束年份" style="width: 120px" @on-change="getEndYear"></DatePicker>
        </div>
        <div style="margin-top: 10px">
          <div style="display: flex; align-items: center">
            <div style="margin-right: 10px">姓别:</div>
            <RadioGroup v-model="formItem.gender">
              <Radio label="1" border>男</Radio>
              <Radio label="2" border>女</Radio>
            </RadioGroup>
          </div>
        </div>
        <div style="margin-top: 10px" v-if="formItem.timeType==2">
          <div style="display: flex; align-items: center">
            <div style="margin-right: 10px">出生地点:</div>
            <Cascader :data="formItem.cascaderData" v-model="formItem.cascaderValue" trigger="hover" @on-change="onGetCityName"></Cascader>
            <div style="margin:0 10px 0 20px">经度:</div>
            <Input v-model="formItem.birth_longitude" placeholder="输入出生地经度" @on-change="changeLongitude" clearable style="width: 120px" />
            <!-- <Button type="primary" style="margin-left: 10px" @click="share.open = true">地图定位</Button> -->

          </div>
        </div>
      </div>
      <div style="margin-top: 10px; display: flex; align-items: center">
        <div style="margin-right: 10px; margin-left: 10px">出生日期:</div>
        <Select v-model="formItem.calendarModel" style="width: 80px;margin-right: 5px;">
          <Option v-for="item in calendarList" :value="item.value" :key="item.value">{{ item.label }}</Option>
        </Select>
        <DatePicker type="year" :value="formItem.yearValue" format="yyyy" style="width: 80px" @on-change="getYearValue"></DatePicker>
        <span style="padding:0 5px">年</span>
        <Select v-model="formItem.monthValue" placeholder="" @on-change="getMonthValue" style="width: 70px">
          <Option v-for="item in monthList" :value="item.value" :key="item.value">{{ item.label }}</Option>
        </Select>
        <span style="padding:0 5px">月</span>
        <Select v-model="formItem.dayValue" @on-change="getDayValue" placeholder="" style="width: 70px">
          <Option v-for="item in dayList" :value="item.value" :key="item.value">{{ item.label }}</Option>
        </Select>
        <span style="padding:0 5px">日</span>
        <Select v-model="formItem.hourValue" @on-change="getHourValue" placeholder="" style="width: 70px">
          <Option v-for="item in hourList" :value="item.value" :key="item.value">{{ item.label }}</Option>
        </Select>
        <span style="padding:0 5px">时</span>
        <Select v-model="formItem.minuteValue" @on-change="getMinuteValue" placeholder="" style="width: 70px">
          <Option v-for="item in minuteList" :value="item.value" :key="item.value">{{ item.label }}</Option>
        </Select>
        <span style="padding:0 5px">分</span>
      </div>
      <div style="margin-top: 10px;margin-left: 10px">
        <div style="display: flex; align-items: center">
          <div style="margin-right: 10px">时间模式:</div>
          <RadioGroup v-model="formItem.timeType">
            <Radio label="1" border>按北京时起局</Radio>
            <Radio label="2" border>按城市经度起真太阳时起局</Radio>
          </RadioGroup>
          <div style="margin-left: 20px">
            <Button type="error" @click="submitPredicted">排盘</Button>
          </div>
        </div>
      </div>
      <!-- 结果信息 -->
      <div style="
          display: flex;
          flex-direction: column;
          font-size: 16px;
        ">
        <Tabs :animated="false" value="八字排盘" style="margin-top: 1vw">
          <TabPane label="八字排盘" name='八字排盘'>
            <table class="bazitable">
              <tbody>
                <tr>
                  <td class="font-bold">北京时间：</td>
                  <td colspan="10" class="left" :class="{'color-red':formItem.timeType==1}"> {{ beijingTime.full }}</td>
                </tr>
                <tr>
                  <td class="font-bold">平太阳时：</td>
                  <td colspan="10" class="left"> {{ meanSolarTime.full }}</td>
                </tr>
                <tr>
                  <td class="font-bold">真太阳时：</td>
                  <td colspan="10" class="left" :class="{'color-red':formItem.timeType==2}"> {{ sunSolarTime.full }}</td>
                </tr>
                <tr>
                  <td class="font-bold">农历：</td>
                  <td colspan="3" class="left"> {{ dataSet.lunar.full }}</td>
                  <td> {{ dataSet.lunar.week }}</td>
                   <td> {{ dataSet.lunar.leapMonth }}</td>
                </tr>
                <tr>
                  <td class="font-bold" rowspan="5" valign="top">{{baziGender}}</td>
                  <td colspan="1"></td>
                  <td>年柱</td>
                  <td>月柱</td>
                  <td>日柱</td>
                  <td>时柱</td>
                </tr>
                <tr>
                  <td colspan="1" class="font-bold">天干十神</td>
                  <td class="small">
                    <div class="red">{{dataSet.tianganshishen.year}}</div>
                  </td>
                  <td class=" small">
                    <div class="red">{{dataSet.tianganshishen.month}}</div>
                  </td>
                  <td class=" small">
                    <div class="red">{{dataSet.tianganshishen.day}}</div>
                  </td>
                  <td class=" small">
                    <div class="red">{{dataSet.tianganshishen.hour}}</div>
                  </td>
                  <td></td>
                </tr>
                <tr>
                  <td colspan="1" class="font-bold">天干地支
                  </td>
                  <td class=" bazi">{{dataSet.tiangan.year}}<br>{{dataSet.dizhi.year}}</td>
                  <td class="bazi">{{dataSet.tiangan.month}}<br>{{dataSet.dizhi.month}}</td>
                  <td class="bazi">{{dataSet.tiangan.day}}<br>{{dataSet.dizhi.day}}</td>
                  <td class="bazi">{{dataSet.tiangan.hour}}<br>{{dataSet.dizhi.hour}}</td>
                  <td></td>
                </tr>
                <tr>
                  <td colspan="1" class="font-bold">地支臧干</td>
                  <td valign="top" class="small">
                    <div :class="{red:index==0}" v-if="dataSet.dizhizanggan.year" v-for="(item,index) in dataSet.dizhizanggan.year">
                      {{dataSet.dizhizanggan.year[index]}}-{{dataSet.dizhishishen.year[index]}}
                    </div>
                  </td>
                  <td valign="top" class="small">
                    <div :class="{red:index==0}" v-if="dataSet.dizhizanggan.month" v-for="(item,index) in dataSet.dizhizanggan.month">
                      {{dataSet.dizhizanggan.month[index]}}-{{dataSet.dizhishishen.month[index]}}
                    </div>
                  </td>
                  <td valign="top" class="small">
                    <div :class="{red:index==0}" v-if="dataSet.dizhizanggan.day" v-for="(item,index) in dataSet.dizhizanggan.day">
                      {{dataSet.dizhizanggan.day[index]}}-{{dataSet.dizhishishen.day[index]}}
                    </div>
                  </td>
                  <td valign="top" class="small">
                    <div :class="{red:index==0}" v-if="dataSet.dizhizanggan.hour" v-for="(item,index) in dataSet.dizhizanggan.hour">
                      {{dataSet.dizhizanggan.hour[index]}}-{{dataSet.dizhishishen.hour[index]}}
                    </div>
                  </td>
                </tr>
                <!-- 寻空 -->
                <tr>
                  <td colspan="1" class="font-bold">旬空</td>
                  <td class="small">
                    <div>{{dataSet.xunKong.year}}</div>
                  </td>
                  <td class=" small">
                    <div>{{dataSet.xunKong.month}}</div>
                  </td>
                  <td class=" small">
                    <div>{{dataSet.xunKong.day}}</div>
                  </td>
                  <td class=" small">
                    <div>{{dataSet.xunKong.hour}}</div>
                  </td>
                </tr>

                <!-- 纳音 -->
                <tr>
                  <td colspan="1"  class="font-bold"></td>
                  <td colspan="1" class="font-bold">纳音</td>
                  <td class="small">
                    <div>{{dataSet.nayin.year}}</div>
                  </td>
                  <td class="small">
                    <div>{{dataSet.nayin.month}}</div>
                  </td>
                  <td class="small">
                    <div>{{dataSet.nayin.day}}</div>
                  </td>
                  <td class="small">
                    <div>{{dataSet.nayin.hour}}</div>
                  </td>
                </tr>
<!--起运---->

                <tr>
                  <td class="font-bold">起运：</td>
                  <td colspan="5" class="left">起运公历 {{dataSet.qiyun.gongli}} ({{dataSet.qiyun.time}})</td>
                </tr>
                <tr>
                  <td class="font-bold">周岁：</td>
                  <td v-for="item in dataSet.dayun.daYunArr">{{item.getStartAge()}}岁</td>
                </tr>
                <tr>
                  <td class="font-bold">换运：</td>
                  <td v-for="item in dataSet.dayun.daYunArr">{{item.getStartYear()}}</td>
                </tr>
                <tr>
                  <td class="font-bold">运程：</td>
                  <td class="font-bold" v-for="(item,index) in dataSet.dayun.daYunArr" :class="{active:formItem.haulIndex  == index}" @click="changeHaul(index)">{{item.getGanZhi()}}</td>
                </tr>
                <tr>
                  <td class="font-bold">小运：</td>
                  <td v-for="item in dataSet.xiaoYun">{{item.getGanZhi()}}</td>
                </tr>
                <tr style="border-top: 1px solid #eee;">
                  <td rowspan="3" valign="middle" class="font-bold">流年：</td>
                  <td v-for="item in dataSet.liuNian">{{item.getYear()}}</td>
                </tr>
                <tr>
                  <td v-for="item in dataSet.liuNian">{{item.getAge()}}岁</td>
                </tr>
                <tr>
                  <td v-for="(item,index) in dataSet.liuNian" :class="{active:formItem.liuNianIndex  == index}" @click="changeLiuNian(index)">{{item.getGanZhi()}}</td>
                </tr>
                <tr>
                  <td rowspan="2" valign="middle" class="font-bold">流月：</td>
                  <td v-for="item in dataSet.liuYue">{{item.getMonthInChinese()}}</td>
                </tr>
                <tr>
                  <td v-for="item in dataSet.liuYue">{{item.getGanZhi()}}</td>
                </tr>
              </tbody>
            </table>
          </TabPane>
          <TabPane label="奇门遁甲排盘" name='奇门遁甲排盘'>
            <div v-if="qimenVar.outstr.length">
              <div class="flex-h">
                <label class="font-bold">时间:</label>
                <div>{{ qimenVar.outstr[0]}}</div>
              </div>
              <div class="flex-h">
                <label class="font-bold">农历:</label>
                <div>{{ qimenVar.outstr[1]}}</div>
              </div>
              <div class="flex-h">
                <label class="font-bold">节气:</label>
                <div>{{ qimenVar.outstr[2]}}</div>
              </div>
              <div class="flex-h">
                <label class="font-bold"></label>
                <div>{{ qimenVar.outstr[3]}}</div>
              </div>
              <div class="flex-h">
                <label class="font-bold">干支:</label>
                <div class="color-blue">{{ qimenVar.outstr[4]}}</div>
              </div>
              <div class="flex-h">
                <label class="font-bold">旬空:</label>
                <div class="color-red">{{ qimenVar.outstr[5]}}</div>
              </div>
              <div class="flex-h" style="margin-top:10px;">
                <label class="font-bold" style="color:rgb(0, 128, 0)">{{qimenVar.jieqi}}:</label>
                <div style="color:red;font-weight:bold;">{{ qimenVar.yuan}}</div>
              </div>
              <div class="flex-h"  style="margin-top:10px;">
                <div>{{qimenVar.jiju}}</div>
                <div style="margin:0 10px;">{{ qimenVar.zhifustr}}</div>
                <div >{{ qimenVar.zhishistr}}</div>
              </div>
            </div>
            <div class="container">
              <div class="col-md-6 col-md-offset-3">
                <table class="ptb" border="0" cellspacing="0" cellpadding="0">
                  <tbody>
                    <tr id="line1">
                      <td class="r1t0">
                        <p class="gua mu" id="k1s1">4巽</p>
                      </td>
                      <td class="r1t0">
                        <p id="k2s1">
                          {{ qimenVar.bashen["4"] }}&nbsp;
                        </p>
                      </td>
                      <td class="r2t0">
                        <p id="k3s1">&nbsp;</p>
                      </td>
                      <td class="r1t0">
                        <p class="gua huo" id="k4s1">9离</p>
                      </td>
                      <td class="r1t0">
                        <p id="k5s1">
                          {{ qimenVar.bashen["9"] }}&nbsp;
                        </p>
                      </td>
                      <td class="r2t0">
                        <p id="k6s1">&nbsp;</p>
                      </td>
                      <td class="r1t0">
                        <p class="gua tu" id="k7s1">2坤</p>
                      </td>
                      <td class="r1t0">
                        <p id="k8s1">
                          {{ qimenVar.bashen["2"] }}&nbsp;
                        </p>
                      </td>
                      <td class="r0t0">
                        <p id="k9s1">
                          &nbsp;
                        </p>
                      </td>
                    </tr>
                    <tr id="line2">
                      <td class="r1t1">
                        <p id="wu5" class="color-red">
                          {{ qimenVar.kongWang["4"] }}&nbsp;
                        </p>
                      </td>
                      <td class="r1t1">
                        <p class="xing" id="xing5">
                          {{ qimenVar.bamen["4"] }}&nbsp;
                        </p>
                      </td>
                      <td class="r2t1">
                        <p id="tianPanDiZhi4">
                          {{ qimenVar.tianPanTianGan["4"] }}&nbsp;
                        </p>
                      </td>
                      <td class="r1t1">
                        <p id="wu6" class="color-red">
                          {{ qimenVar.kongWang["9"] }}&nbsp;
                        </p>
                      </td>
                      <td class="r1t1">
                        <p class="xing" id="xing6">
                          {{ qimenVar.bamen["9"] }}&nbsp;
                        </p>
                      </td>
                      <td class="r2t1">
                        <p id="tianPanDiZhi9">
                          {{ qimenVar.tianPanTianGan["9"] }}&nbsp;
                        </p>
                      </td>
                      <td class="r1t1">
                        <p id="wu7" class="color-red">
                          {{ qimenVar.kongWang["2"] }}&nbsp;
                        </p>
                      </td>
                      <td class="r1t1">
                        <p class="xing" id="xing7">
                          {{ qimenVar.bamen["2"] }}&nbsp;
                        </p>
                      </td>
                      <td class="r0t1">
                        <p id="tianPanDiZhi2">
                          {{ qimenVar.tianPanTianGan["2"] }}&nbsp;
                        </p>
                      </td>
                    </tr>
                    <tr id="line3">
                      <td class="r1t1">
                        <p class="xing" id="tianqin5">
                          {{ qimenVar.leftTianGan["4"] }}&nbsp;
                        </p>
                      </td>
                      <td class="r1t1">
                        <p class="xing" id="xing5">
                          {{ qimenVar.jiuxing["4"] }}&nbsp;
                        </p>
                      </td>
                      <td class="r2t1">
                        <p class="diPanTianGan" id="diPanTianGan4">
                          {{ qimenVar.diPanTianGan["4"] }}&nbsp;
                        </p>
                      </td>
                      <td class="r1t1">
                        <p class="xing" id="tianqin6">
                          {{ qimenVar.leftTianGan["9"] }}&nbsp;
                        </p>
                      </td>
                      <td class="r1t1">
                        <p class="xing" id="xing6">
                          {{ qimenVar.jiuxing["9"] }}&nbsp;
                        </p>
                      </td>
                      <td class="r2t1">
                        <p class="diPanTianGan" id="diPanTianGan9">
                          {{ qimenVar.diPanTianGan["9"] }}&nbsp;
                        </p>
                      </td>
                      <td class="r1t1">
                        <p class="xing" id="tianqin7">
                          {{ qimenVar.leftTianGan["2"] }}&nbsp;
                        </p>
                      </td>
                      <td class="r1t1">
                        <p class="xing" id="xing7">
                          {{ qimenVar.jiuxing["2"] }}&nbsp;
                        </p>
                      </td>
                      <td class="r0t1">
                        <p class="diPanTianGan" id="diPanTianGan2">
                          {{ qimenVar.diPanTianGan["2"] }}&nbsp;
                        </p>
                      </td>
                    </tr>
                    <!--中间-->
                    <tr id="line4">
                      <td class="r1t2">
                        <p class="gua mu" id="k1s4">3震</p>
                      </td>
                      <td class="r1t2">
                        <p id="k2s4">
                          {{ qimenVar.bashen["3"] }}&nbsp;
                        </p>
                      </td>
                      <td class="r2t2">
                        <p id="k3s4">&nbsp;</p>
                      </td>
                      <td class="r1t2">
                        <p class="gua tu" id="k4s4">5 &nbsp;</p>
                      </td>
                      <td class="r1t2">
                        <p id="k5s4">&nbsp;</p>
                      </td>
                      <td class="r2t2">
                        <p id="k6s4">&nbsp;</p>
                      </td>
                      <td class="r1t2">
                        <p class="gua jin" id="k7s4">7兑</p>
                      </td>
                      <td class="r1t2">
                        <p id="k8s4">
                          {{ qimenVar.bashen["7"] }}&nbsp;
                        </p>
                        </p>
                      </td>
                      <td class="r0t2">
                        <p id="k9s4">&nbsp;</p>
                      </td>
                    </tr>
                    <tr id="line5">
                      <td class="r1t1">
                        <p id="wu4" class="color-red">
                          {{ qimenVar.kongWang["3"] }}&nbsp;
                        </p>
                      </td>
                      <td class="r1t1">
                        <p class="xing" id="xing4">
                          {{ qimenVar.bamen["3"] }}&nbsp;
                        </p>
                      </td>
                      <td class="r2t1">
                        <p id="tianPanDiZhi3">
                          {{ qimenVar.tianPanTianGan["3"] }}&nbsp;
                        </p>
                      </td>
                      <td class="r1t1">
                        <!-- <p id="wu">&nbsp;</p> -->
                      </td>
                      <td class="r1t1">
                        <div class="r-center">
                          <div>{{qimenVar.jiju}}</div>
                          <div>{{qimenVar.zhifu}}</div>
                        </div>
                      </td>
                      <td class="r2t1">
                        <!-- <p id="tianPanDiZhi5">&nbsp;</p> -->
                      </td>
                      <td class="r1t1">
                        <p id="wu8" class="color-red">
                          {{ qimenVar.kongWang["7"] }}&nbsp;
                        </p>
                      </td>
                      <td class="r1t1">
                        <p class="xing" id="xing8">
                          {{ qimenVar.bamen["7"] }}&nbsp;
                        </p>
                      </td>
                      <td class="r0t1">
                        <p id="tianPanDiZhi7">
                          {{ qimenVar.tianPanTianGan["7"] }}&nbsp;
                        </p>
                      </td>
                    </tr>
                    <tr id="line6">
                      <td class="r1t1">
                        <p class="xing" id="tianqin4">
                          {{ qimenVar.leftTianGan["3"] }}&nbsp;
                        </p>
                      </td>
                      <td class="r1t1">
                        <p class="xing" id="xing4">
                          {{ qimenVar.jiuxing["3"] }}&nbsp;
                        </p>
                      </td>
                      <td class="r2t1">
                        <p class="diPanTianGan" id="diPanTianGan3">
                          {{ qimenVar.diPanTianGan["3"] }}&nbsp;
                        </p>
                      </td>
                      <td class="r1t1">
                        <p class="xing" id="tianqinx">&nbsp;</p>
                      </td>
                      <td class="r1t1">
                        <p class="xing" id="xingx">&nbsp;</p>
                      </td>
                      <td class="r2t1">
                        <p class="diPanTianGan" id="diPanTianGan5">
                          {{ qimenVar.diPanTianGan["5"] }}&nbsp;
                        </p>
                      </td>
                      <td class="r1t1">
                        <p class="xing" id="tianqin8"> {{ qimenVar.leftTianGan["7"] }}&nbsp;</p>
                      </td>
                      <td class="r1t1">
                        <p class="xing" id="xing8"> {{ qimenVar.jiuxing["7"] }}&nbsp;</p>
                      </td>
                      <td class="r0t1">
                        <p class="diPanTianGan" id="diPanTianGan7">
                          {{ qimenVar.diPanTianGan["7"] }}&nbsp;
                        </p>
                      </td>
                    </tr>
                    <!--最下一行-->
                    <tr id="line7">
                      <td class="r1t2">
                        <p class="gua tu" id="k1s7">8艮</p>
                      </td>
                      <td class="r1t2">
                        <p id="k2s7">
                          {{ qimenVar.bashen["8"] }}&nbsp;
                        </p>
                      </td>
                      <td class="r2t2">
                        <p id="k3s7">&nbsp;</p>
                      </td>
                      <td class="r1t2">
                        <p class="gua shui" id="k4s7">1坎</p>
                      </td>
                      <td class="r1t2">
                        <p id="k5s7">
                          {{ qimenVar.bashen["1"] }}&nbsp;
                        </p>
                      </td>
                      <td class="r2t2">
                        <p id="k6s7">&nbsp;</p>
                      </td>
                      <td class="r1t2">
                        <p class="gua jin" id="k7s7">6乾</p>
                      </td>
                      <td class="r1t2">
                        <p id="k8s7">
                          {{ qimenVar.bashen["6"] }}&nbsp;
                        </p>
                      </td>
                      <td class="r0t2">
                        <p id="k9s7">&nbsp;</p>
                      </td>
                    </tr>
                    <tr id="line8">
                      <td class="r1t1">
                        <p id="wu3" class="color-red">
                          {{ qimenVar.kongWang["8"] }}&nbsp;
                        </p>
                      </td>
                      <td class="r1t1">
                        <p class="xing" id="xing3">
                          {{ qimenVar.bamen["8"] }}&nbsp;
                        </p>
                      </td>
                      <td class="r2t1">
                        <p id="tianPanDiZhi8">
                          {{ qimenVar.tianPanTianGan["8"] }}&nbsp;
                        </p>
                      </td>
                      <td class="r1t1 color-red" >
                        {{ qimenVar.kongWang["1"] }}&nbsp;
                      </td>
                      <td class="r1t1">
                        <p class="xing" id="xing2">
                          {{ qimenVar.bamen["1"] }}&nbsp;
                        </p>
                      </td>
                      <td class="r2t1">
                        <p id="tianPanDiZhi1">
                          {{ qimenVar.tianPanTianGan["1"] }}&nbsp;
                        </p>
                      </td>
                      <td class="r1t1">
                        <p id="wu1" class="color-red">
                          {{ qimenVar.kongWang["6"] }}&nbsp;
                        </p>
                      </td>
                      <td class="r1t1">
                        <p class="xing" id="xing1">
                          {{ qimenVar.bamen["6"] }}&nbsp;
                        </p>
                      </td>
                      <td class="r0t1">
                        <p id="tianPanDiZhi6">
                          {{ qimenVar.tianPanTianGan["6"] }}&nbsp;
                        </p>
                      </td>
                    </tr>
                    <tr id="line9">
                      <td class="r1t1">
                        <p class="xing" id="tianqin3"> {{ qimenVar.leftTianGan["8"] }}&nbsp; </p>
                      </td>
                      <td class="r1t1">
                        <p class="xing" id="xing3">
                          {{ qimenVar.jiuxing["8"] }}&nbsp;
                        </p>
                      </td>
                      <td class="r2t1">
                        <p class="diPanTianGan" id="diPanTianGan8">
                          {{ qimenVar.diPanTianGan["8"] }}&nbsp;
                        </p>
                      </td>
                      <td class="r1t1">
                        <p class="xing" id="tianqin2"> {{ qimenVar.leftTianGan["1"] }}&nbsp; </p>
                      </td>
                      <td class="r1t1">
                        <p class="xing" id="xing2">
                          {{ qimenVar.jiuxing["1"] }}&nbsp;
                        </p>
                      </td>
                      <td class="r2t1">
                        <p class="diPanTianGan" id="diPanTianGan1">
                          {{ qimenVar.diPanTianGan["1"] }}&nbsp;
                        </p>
                      </td>
                      <td class="r1t1">
                        <p class="xing" id="tianqin1"> {{ qimenVar.leftTianGan["6"] }}&nbsp; </p>
                      </td>
                      <td class="r1t1">
                        <p class="xing" id="xing1">
                          {{ qimenVar.jiuxing["6"] }}&nbsp;
                        </p>
                      </td>
                      <td class="r0t1">
                        <p class="diPanTianGan" id="diPanTianGan6">
                          {{ qimenVar.diPanTianGan["6"] }}&nbsp;
                        </p>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </TabPane>
          <TabPane label="预测图">
            <div class="preview-left-bottom">
              <div class="preview-left-row" v-for="(item, index) in predictedMap" :key="index">
                <ul class="preview-year">
                  <li :class="{ active: predictedBall.year == index }">
                    {{ dataSet.lunar.year }}年
                  </li>
                  <li :class="{ active: predictedBall.month == index }">
                    {{ dataSet.lunar.month }}月
                  </li>
                  <li :class="{ active: predictedBall.day == index }">
                    {{ dataSet.lunar.day }}日
                  </li>
                  <li :class="{ active: predictedBall.time == index }">
                    {{ dataSet.lunar.hour }}时
                  </li>
                </ul>
                <div>
                  <Icon :type="
                    index > 2 ? 'md-arrow-round-back' : 'md-arrow-round-forward'
                  " color="#ed4014" />
                  {{ getIndex(index) }}
                </div>
                <ul class="preview-left-ul">
                  <li class="preview-left-li" v-for="(year, index) in item" :key="index">
                    {{ year }}
                  </li>
                </ul>
              </div>
            </div>
          </TabPane>
          <TabPane label="八字命盘">
            <table width="100%" border="0" cellpadding="2" cellspacing="2" bgcolor="#A3E7FA" style="margin-bottom: 5px; table-layout: fixed; word-wrap: break-word">
              <tbody>
                <tr>
                  <td width="3%" rowspan="13" bgcolor="#FFFFFF" class="new">
                    <b>生</b><br /><br />
                    <b>辰</b> <br /><br />
                    <b>八</b> <br /><br />
                    <b>字</b> <br /><br />
                    <b>命</b> <br /><br />
                    <b>盘</b> <br /><br />
                  </td>
                  <td width="5%" rowspan="4" bgcolor="#FFFFFF" class="new" style="padding-left:20px;padding-top:20px;">
                    <b>出</b><br /><br />
                    <b>生</b> <br /><br />
                    <b>时</b> <br /><br />
                    <b>辰</b> <br /><br />
                  </td>
                  <td width="8%" bgcolor="#FFFFFF" class="new">北京时间</td>
                  <td width="10%" bgcolor="#FFFFFF" class="new">
                    {{ beijingTime.year }}年
                  </td>
                  <td width="10%" bgcolor="#FFFFFF" class="new">
                    {{ beijingTime.month }}月
                  </td>
                  <td width="10%" bgcolor="#FFFFFF" class="new">
                    {{ beijingTime.day }}日
                  </td>
                  <td width="10%" bgcolor="#FFFFFF" class="new">
                    {{ beijingTime.hour }}时
                  </td>
                  <td width="7%" bgcolor="#FFFFFF" class="new">
                    {{ beijingTime.minute }}分
                  </td>
                </tr>
                <tr>
                  <td width="9%" bgcolor="#FFFFFF" class="new">平太阳时</td>
                  <td width="12%" bgcolor="#FFFFFF" class="new">
                    {{ meanSolarTime.year }}年
                  </td>
                  <td width="10%" bgcolor="#FFFFFF" class="new">
                    {{ meanSolarTime.month }}月
                  </td>
                  <td width="10%" bgcolor="#FFFFFF" class="new">
                    {{ meanSolarTime.day }}日
                  </td>
                  <td width="10%" bgcolor="#FFFFFF" class="new">
                    {{ meanSolarTime.hour }}时
                  </td>
                  <td width="10%" bgcolor="#FFFFFF" class="new">
                    {{ meanSolarTime.minute }}分
                  </td>
                </tr>
                <tr>
                  <td width="9%" bgcolor="#FFFFFF" class="new">真太阳时</td>
                  <td width="12%" bgcolor="#FFFFFF" class="new">
                    {{ sunSolarTime.year }}年
                  </td>
                  <td width="10%" bgcolor="#FFFFFF" class="new">
                    {{ sunSolarTime.month }}月
                  </td>
                  <td width="10%" bgcolor="#FFFFFF" class="new">
                    {{ sunSolarTime.day }}日
                  </td>
                  <td width="10%" bgcolor="#FFFFFF" class="new">
                    {{ sunSolarTime.hour }}时
                  </td>
                  <td width="10%" bgcolor="#FFFFFF" class="new">
                    {{ sunSolarTime.minute }}分
                  </td>
                </tr>
                <tr>
                  <td bgcolor="#FFFFFF" class="new">农历</td>
                  <td bgcolor="#FFFFFF" class="new">
                    {{ dataSet.lunar.year }}年
                    </br>
                    {{ dataSet.lunar.yearcn }}年
                  </td>
                  <td bgcolor="#FFFFFF" class="new">
                    {{ dataSet.lunar.month }}月
                    </br>
                    {{ dataSet.lunar.monthcn }}年
                  </td>
                  <td bgcolor="#FFFFFF" class="new">
                    {{ dataSet.lunar.day }}日
                    </br>
                    {{ dataSet.lunar.daycn }}年
                  </td>
                  <td bgcolor="#FFFFFF" class="new">
                    {{ dataSet.lunar.week }}
                  </td>
                  <td bgcolor="#FFFFFF" class="new">
                    {{ dataSet.lunar.leapMonth }}
                  </td>
                </tr>
                <!-- 2 -->
                <tr>
                  <td colspan="2" bgcolor="#FFFFFF" class="new">天干：</td>
                  <td bgcolor="#FFFFFF" class="new">{{ dataSet.tiangan.year }}</td>
                  <td bgcolor="#FFFFFF" class="new">{{ dataSet.tiangan.month }}</td>
                  <td bgcolor="#FFFFFF" class="new">{{ dataSet.tiangan.day }}</td>
                  <td bgcolor="#FFFFFF" class="new">{{ dataSet.tiangan.hour }}</td>
                  <td bgcolor="#FFFFFF" class="new"></td>
                </tr>
                <tr>
                  <td colspan="2" bgcolor="#FFFFFF" class="new">天干十神：</td>
                  <td bgcolor="#FFFFFF" class="new">{{ dataSet.tianganshishen.year }}</td>
                  <td bgcolor="#FFFFFF" class="new">{{ dataSet.tianganshishen.month }}</td>
                  <td bgcolor="#FFFFFF" class="new">{{ dataSet.tianganshishen.day }}</td>
                  <td bgcolor="#FFFFFF" class="new">{{ dataSet.tianganshishen.hour }}</td>
                  <td bgcolor="#FFFFFF" class="new"></td>
                </tr>
                <tr>
                  <td colspan="2" bgcolor="#FFFFFF" class="new">地支：</td>
                  <td bgcolor="#FFFFFF" class="new">{{ dataSet.dizhi.year }}</td>
                  <td bgcolor="#FFFFFF" class="new">{{ dataSet.dizhi.month }}</td>
                  <td bgcolor="#FFFFFF" class="new">{{ dataSet.dizhi.day }}</td>
                  <td bgcolor="#FFFFFF" class="new">{{ dataSet.dizhi.hour }}</td>
                  <td bgcolor="#FFFFFF" class="new"></td>
                </tr>
                <tr>
                  <td colspan="2" bgcolor="#FFFFFF" class="new">地支藏干：</td>
                  <td bgcolor="#FFFFFF" class="new">{{ dataSet.dizhizanggan.year }}</td>
                  <td bgcolor="#FFFFFF" class="new">{{ dataSet.dizhizanggan.month }}</td>
                  <td bgcolor="#FFFFFF" class="new">{{ dataSet.dizhizanggan.day }}</td>
                  <td bgcolor="#FFFFFF" class="new">{{ dataSet.dizhizanggan.hour }}</td>
                  <td bgcolor="#FFFFFF" class="new"></td>
                </tr>
                <tr>
                  <td colspan="2" bgcolor="#FFFFFF" class="new">地支十神：</td>
                  <td bgcolor="#FFFFFF" class="new">{{ dataSet.dizhishishen.year }}</td>
                  <td bgcolor="#FFFFFF" class="new">{{ dataSet.dizhishishen.month }}</td>
                  <td bgcolor="#FFFFFF" class="new">{{ dataSet.dizhishishen.day }}</td>
                  <td bgcolor="#FFFFFF" class="new">{{ dataSet.dizhishishen.hour }}</td>
                  <td bgcolor="#FFFFFF" class="new"></td>
                </tr>
                <tr>
                  <td colspan="2" bgcolor="#FFFFFF" class="new">地势(长生十二神)：</td>
                  <td bgcolor="#FFFFFF" class="new">{{ dataSet.dishi.year }}</td>
                  <td bgcolor="#FFFFFF" class="new">{{ dataSet.dishi.month }}</td>
                  <td bgcolor="#FFFFFF" class="new">{{ dataSet.dishi.day }}</td>
                  <td bgcolor="#FFFFFF" class="new">{{ dataSet.dishi.hour }}</td>
                  <td bgcolor="#FFFFFF" class="new"></td>
                </tr>
                <tr>
                  <td colspan="2" bgcolor="#FFFFFF" class="new">八字：</td>
                  <td bgcolor="#FFFFFF" class="new">{{ dataSet.bazi.year }}</td>
                  <td bgcolor="#FFFFFF" class="new">{{ dataSet.bazi.month }}</td>
                  <td bgcolor="#FFFFFF" class="new">{{ dataSet.bazi.day }}</td>
                  <td bgcolor="#FFFFFF" class="new">{{ dataSet.bazi.hour }}</td>
                  <td bgcolor="#FFFFFF" class="new"></td>
                </tr>
                <tr>
                  <td colspan="2" bgcolor="#FFFFFF" class="new">五行：</td>
                  <td bgcolor="#FFFFFF" class="new">{{ dataSet.wuxing.year }}</td>
                  <td bgcolor="#FFFFFF" class="new">{{ dataSet.wuxing.month }}</td>
                  <td bgcolor="#FFFFFF" class="new">{{ dataSet.wuxing.day }}</td>
                  <td bgcolor="#FFFFFF" class="new">{{ dataSet.wuxing.hour }}</td>
                  <td bgcolor="#FFFFFF" class="new"></td>
                </tr>
                <tr>
                  <td colspan="2" bgcolor="#FFFFFF" class="new">纳音：</td>
                  <td bgcolor="#FFFFFF" class="new">{{ dataSet.nayin.year }}</td>
                  <td bgcolor="#FFFFFF" class="new">{{ dataSet.nayin.month }}</td>
                  <td bgcolor="#FFFFFF" class="new">{{ dataSet.nayin.day }}</td>
                  <td bgcolor="#FFFFFF" class="new">{{ dataSet.nayin.hour }}</td>
                  <td bgcolor="#FFFFFF" class="new">
                  </td>
                </tr>
              </tbody>
            </table>
            <ul>
              <li>胎元：{{dataSet.taiyuan}}</li>
              <li>命宫：{{dataSet.minggong}}</li>
              <li>身宫：{{dataSet.shengong}}</li>
              <li>起运：{{dataSet.qiyun.time}}</li>
            </ul>
          </TabPane>
        </Tabs>
      </div>
      <!-- 预测图 -->
    </div>
    <!-- 右边 -->
    <div class="preview-right">
      <div class="preview-right-top">
        <Divider>右边面板</Divider>
      </div>
      <div class="demo-split">
        <Split v-model="layout.split">
          <div slot="left" class="demo-split-pane">
            <Tabs :animated="false" value="对冲球" style="margin-top: 1vw" @on-click="getinfo1">
              <TabPane label="对冲球" name='对冲球'>
                <div>
                  <div class="birth_time">
                    <div class="birth_time_name">出生时辰</div>
                    <div class="birth_time_roll" :style="{backgroundColor:birthChecked['年']?'#dcdee2':''}">年</div>
                    <div class="birth_time_roll" :style="{backgroundColor:birthChecked['月']?'#dcdee2':''}">月</div>
                    <div class="birth_time_roll" :style="{backgroundColor:birthChecked['日']?'#dcdee2':''}">日</div>
                    <div class="birth_time_roll" :style="{backgroundColor:birthChecked['时']?'#dcdee2':''}">时</div>
                  </div>
                  <div class="now_time">
                    <div class="now_time_name">当前时辰</div>
                    <div class="now_time_roll" :style="{backgroundColor:nowChecked['年']?'#dcdee2':''}">年</div>
                    <div class="now_time_roll" :style="{backgroundColor:nowChecked['月']?'#dcdee2':''}">月</div>
                    <div class="now_time_roll" :style="{backgroundColor:nowChecked['日']?'#dcdee2':''}">日</div>
                    <div class="now_time_roll" :style="{backgroundColor:nowChecked['时']?'#dcdee2':''}">时</div>
                  </div>
                </div>
                <div class="preview-right-bottom">
                  <div class="preview-right-frame">
                    <div class="preview-right-row" v-for="(d, i) in [0, 1, 2]" :key="i">
                      <div class="preview-right-col" @click="changeModal(i)" :class="{active:modelVar.index===i}">
                        <ul class="preview-right-ul">
                          <li class="preview-right-ball" v-for="(item, index) in createVar[i].birth" :key="index">
                            {{item}}
                          </li>
                        </ul>
                        <ul class="preview-right-ul">
                          <li class="preview-right-ball" style="background-color:#2C8CF1" v-for="(item, index) in createVar[i].now" :key="index">
                            {{item}}
                          </li>
                        </ul>
                      </div>
                      <div class="preview-right-line"></div>
                      <div class="preview-right-col" @click="changeModal(i+3)" :class="{active:modelVar.index===i+3}">
                        <ul class="preview-right-ul">
                          <li class="preview-right-ball" v-for="(item, index) in createVar[i + 3].birth" :key="index">
                            {{item}}
                          </li>
                        </ul>
                        <ul class="preview-right-ul">
                          <li class="preview-right-ball" style="background-color:#2C8CF1" v-for="(item, index) in createVar[i + 3].now" :key="index">
                            {{item}}
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </TabPane>
              <TabPane label="搜索" name='搜索'>
                <Form :model="findform" :label-width="80">
                  <FormItem label="查询">
                    <Input v-model="findform.data_val" size="large" placeholder="输入搜索对冲数..."   style="width: 300px;">

                    </Input>
                    <el-button
                            type="primary"
                            @click="handleSearchFormSubmit"
                    ><d2-icon name="search" /> 查询
                    </el-button>
                  </FormItem>
                </Form>
                <el-table
                        :data="tableData"
                        v-loading="loading"
                        size="small"
                        stripe
                        highlight-current-row
                        style="width: 100%;"
                        @selection-change="handleSelectionChange"
                        @sort-change="handleSortChange"
                >

                  <el-table-column
                          type="selection"
                          width="55"
                  >
                  </el-table-column>
                  <el-table-column
                          label="对冲数"
                  >
                    <template slot-scope="scope">
                      {{scope.row.data_val}}
                    </template>
                  </el-table-column>

                  <el-table-column
                          label="吉凶"
                          prop="legal"
                          sortable="custom"
                          :show-overflow-tooltip="true"
                  >
                    <template slot-scope="scope">
                      {{scope.row.luck}}
                    </template>
                  </el-table-column>

                  <el-table-column
                          fixed="right"
                          label="操作"
                          align="center"
                          width="150"
                  >
                    <template slot-scope="scope">
                      <el-button type="primary" plain  size="mini"    @click="openEditForm(scope.row)">编辑</el-button>
                      <el-button type="primary" plain  size="mini"    @click="delEditForm(scope.row)">删除</el-button>
                    </template>
                  </el-table-column>

                </el-table>

                 <el-pagination
                         :current-page="page.current"
                          :page-size="page.size"
                          :total="page.total"
                         :page-sizes="[1,10,50,100, 200, 300, 400]"
                          layout="total, sizes, prev, pager, next, jumper"

                         @size-change="handleSizeChange"
                         @current-change="handleCurrentChange"
                  >
                  </el-pagination>

              </TabPane>
            </Tabs>
          </div>
          <div slot="right" class="demo-split-pane">
            <Divider>对冲数</Divider>
            <div class="result-ball">
              <div>
                <div>{{createVar[0].birth.length + createVar[0].now.length}}</div>
                <img src="./image/pillar.png" class="result-ball-pillar"></img>
                <div>{{createVar[3].birth.length + createVar[3].now.length}}</div>
              </div>
              <div>
                <div>{{createVar[1].birth.length + createVar[1].now.length}}</div>
                <img src="./image/pillar.png" class="result-ball-pillar"></img>
                <div>{{createVar[4].birth.length + createVar[4].now.length}}</div>
              </div>
              <div>
                <div>{{createVar[2].birth.length + createVar[2].now.length}}</div>
                <img src="./image/pillar.png" class="result-ball-pillar"></img>
                <div>{{createVar[5].birth.length + createVar[5].now.length}}</div>
              </div>
            </div>
            <Form :model="submitForm" :label-width="80" style="margin-top:30px">
              <FormItem label="测算">
                <RadioGroup v-model="submitForm.luck" type="button" size="large">
                  <Radio label="凶" border></Radio>
                  <Radio label="小吉" border></Radio>
                  <Radio label="中吉" border></Radio>
                  <Radio label="大吉" border></Radio>
                </RadioGroup>
              </FormItem>
              <FormItem label="性别">
                <RadioGroup v-model="submitForm.sex" type="button" size="large">
                  <Radio label="男" border></Radio>
                  <Radio label="女" border></Radio>
                </RadioGroup>
              </FormItem>
              <FormItem label="时间段">
                <TimePicker :value="submitForm.timerange" format="HH:mm" type="timerange" placement="bottom-end" placeholder="选择时间段"  @on-change="dateChangebirthday1"></TimePicker>
              </FormItem>
              <Collapse v-model="collapse_unfold">
                <Panel name="1">
                  出行安全
                  <p slot="content">
                    <Input v-model="submitForm.chuxing" type="textarea" :autosize="{minRows: 2,maxRows: 6}" placeholder="输入评语..."></Input>
                  </p>
                  ({{submitForm.chuxing.length}}字数)
                </Panel>
                <Panel name="2">
                  招财进宝
                  <p slot="content"> <Input v-model="submitForm.caiyun" type="textarea" :autosize="{minRows: 2,maxRows: 6}" placeholder="输入评语..."></Input></p>
                  ({{submitForm.caiyun.length}}字数)
                </Panel>
                <Panel name="3">
                  感情姻缘
                  <p slot="content"> <Input v-model="submitForm.ganqing" type="textarea" :autosize="{minRows: 2,maxRows: 6}" placeholder="输入评语..."></Input></p>
                  ({{submitForm.ganqing.length}}字数)
                </Panel>
                <Panel name="4">
                  情绪管理
                  <p slot="content">
                    <Input v-model="submitForm.qingxu" type="textarea" :autosize="{minRows: 2,maxRows: 6}" placeholder="输入评语..."></Input>
                  </p>
                  ({{submitForm.qingxu.length}}字数)
                </Panel>
                <Panel name="5">
                  商务洽谈
                  <p slot="content"> <Input v-model="submitForm.shangwuqiatan" type="textarea" :autosize="{minRows: 2,maxRows: 6}" placeholder="输入评语..."></Input></p>
                  ({{submitForm.shangwuqiatan.length}}字数)
                </Panel>
                <Panel name="6">
                  约人求见
                  <p slot="content"> <Input v-model="submitForm.yuerenqiujian" type="textarea" :autosize="{minRows: 2,maxRows: 6}" placeholder="输入评语..."></Input></p>
                  ({{submitForm.yuerenqiujian.length}}字数)
                </Panel>
                <Panel name="7">
                  工作事业
                  <p slot="content">
                    <Input v-model="submitForm.gongzuoyiji" type="textarea" :autosize="{minRows: 2,maxRows: 6}" placeholder="输入评语..."></Input>
                  </p>
                  ({{submitForm.gongzuoyiji.length}}字数)
                </Panel>
                <Panel name="8">
                  健康管理
                  <p slot="content"> <Input v-model="submitForm.renshiguanxi" type="textarea" :autosize="{minRows: 2,maxRows: 6}" placeholder="输入评语..."></Input></p>
                  ({{submitForm.renshiguanxi.length}}字数)
                </Panel>
                <Panel name="9">
                  求学考试
                  <p slot="content"> <Input v-model="submitForm.qiuxuekaoyun" type="textarea" :autosize="{minRows: 2,maxRows: 6}" placeholder="输入评语..."></Input></p>
                  ({{submitForm.qiuxuekaoyun.length}}字数)
                </Panel>
                <Panel name="10">
                  修造搬家
                  <p slot="content"> <Input v-model="submitForm.xiuzaobanjia" type="textarea" :autosize="{minRows: 2,maxRows: 6}" placeholder="输入评语..."></Input></p>
                  ({{submitForm.xiuzaobanjia.length}}字数)
                </Panel>
                <Panel name="11">
                  求子备孕
                  <p slot="content"> <Input v-model="submitForm.qiaozibeyun" type="textarea" :autosize="{minRows: 2,maxRows: 6}" placeholder="输入评语..."></Input></p>
                  ({{submitForm.qiaozibeyun.length}}字数)
                </Panel>
                <Panel name="12">
                  桃花情缘
                  <p slot="content"> <Input v-model="submitForm.taohualianqing" type="textarea" :autosize="{minRows: 2,maxRows: 6}" placeholder="输入评语..."></Input></p>
                  ({{submitForm.taohualianqing.length}}字数)
                </Panel>
              </Collapse>
              <div style="display:flex;margin-top:20px;justify-content:center">
                <i-switch v-model="submitForm.switch" size="large" @on-change="changeSwitch">
                  <span slot="open">收紧</span>
                  <span slot="close">展开</span>
                </i-switch>
              </div>
              <FormItem label="一键编辑范围">
                <RadioGroup v-model="submitForm.bjrange" type="button" size="large" @on-change="handleChange">
                  <Radio label="当前记录编辑" border>当前记录编辑</Radio>
                  <Radio label="所有数据编辑" border>所有数据编辑</Radio>
                </RadioGroup>
              </FormItem>
              <FormItem label="一键编辑选择类型">
                <RadioGroup v-model="submitForm.bjtype" type="button" size="large" @on-change="handleChange">
                  <Radio label="文字前" border>文字前</Radio>
                  <Radio label="文字后" border>文字后</Radio>
                  <Radio label="替换" border>替换</Radio>
                </RadioGroup>
              </FormItem>
              <FormItem label="一键编辑内容">
                <Input v-model="submitForm.bjcontent" type="textarea" :autosize="{minRows: 2,maxRows: 6}" placeholder="输入一键编辑内容..."></Input>
              </FormItem>
              <FormItem label="一键编辑需要替换内容"　v-if="isbj">
                <Input v-model="submitForm.bjth" type="textarea" :autosize="{minRows: 2,maxRows: 6}" placeholder="输入一键编辑需替换的内容..."></Input>
              </FormItem>
              <div style="width:90%;margin:20px auto 0 auto">
                <Button type="primary" long size="large"   :loading="loading" @click="submitBj">一键编辑</Button>
              </div>
              <div style="width:90%;margin:20px auto 0 auto">
                <Button type="primary" long size="large"   :loading="loading" @click="submitAll">保存</Button>
              </div>
            </Form>
          </div>
        </Split>
      </div>
    </div>
    <Modal v-model="modelVar.display" cancel-text="" closable ok-text="关闭" draggable title="设置时辰球">
      <div style="border-bottom: 1px solid #e9e9e9;padding-bottom:6px;margin-bottom:6px;">
        <div style="display:flex;justify-content:space-between;">
          出生时辰
          <Button type="primary" @click="resetBirth">重置</Button>
        </div>
      </div>
      <CheckboxGroup v-model="modelVar.birth_social" size="large" @on-change="birthGroupChange">
        <Checkbox label="年" border v-if="!modelVar.birth_lock['年']">
          <Icon type="md-alarm" size="22"></Icon>
          <span style="font-size:20px;">年</span>
        </Checkbox>
        <Checkbox label="月" border v-if="!modelVar.birth_lock['月']">
          <Icon type="md-alarm" size="22"></Icon>
          <span style="font-size:20px">月</span>
        </Checkbox>
        <Checkbox label="日" border v-if="!modelVar.birth_lock['日']">
          <Icon type="md-alarm" size="22"></Icon>
          <span style="font-size:20px">日</span>
        </Checkbox>
        <Checkbox label="时" border v-if="!modelVar.birth_lock['时']">
          <Icon type="md-alarm" size="22"></Icon>
          <span style="font-size:20px">时</span>
        </Checkbox>
      </CheckboxGroup>
      <div style="border-bottom: 1px solid #e9e9e9;padding-bottom:6px;margin-bottom:6px;margin-top:30px">
        <div style="display:flex;justify-content:space-between;">
          出生时辰
          <Button type="primary" @click="resetNow">重置</Button>
        </div>
      </div>
      <CheckboxGroup v-model="modelVar.now_social" size="large" @on-change="nowGroupChange">
        <Checkbox label="年" border v-if="!modelVar.now_lock['年']">
          <Icon type="md-alarm" size="22"></Icon>
          <span style="font-size:20px">年</span>
        </Checkbox>
        <Checkbox label="月" border v-if="!modelVar.now_lock['月']">
          <Icon type="md-alarm" size="22"></Icon>
          <span style="font-size:20px">月</span>
        </Checkbox>
        <Checkbox label="日" border v-if="!modelVar.now_lock['日']">
          <Icon type="md-alarm" size="22"></Icon>
          <span style="font-size:20px">日</span>
        </Checkbox>
        <Checkbox label="时" border v-if="!modelVar.now_lock['时']">
          <Icon type="md-alarm" size="22"></Icon>
          <span style="font-size:20px">时</span>
        </Checkbox>
      </CheckboxGroup>
    </Modal>
  </div>
</template>
<script>
import './css/qimen.css'
import dayjs from 'dayjs'

import { floatSub } from './libs/utils.js'
import dateDiff from './libs/diff.js'
import baziUtils from './libs/lunar.js'
// 数据局
import cityData from './libs/pca-code.js'
import coordinateData from './libs/coordinate.js'

// 时家
import JIQI from './qimen/jiqi.js'
import QIMEN from './qimen/qimen_min.js'
import SPF from './qimen/sprintf.min.js'
import * as agentService from '@/api/sys/agent'
// 真太阳时差
const dateDiffStr = dateDiff.join(',')

function createList (len, i) {
  let list = []
  if (i == 0) {
    i = 0
  } else {
    i = 1
  }
  for (i; i <= len; i++) {
    list.push({
      value: i,
      label: i
    })
  }
  return list
}

export default {
  name: 'preview',
  components: {},
  data () {
    const self = this
    const nowDayObj = dayjs()
    return {
      layout: {
        split: 0.6
      },
      tableData: [],
      multipleSelection: [],
      page: {
        current: 1,
        size: 10,
        total: 0
      },
      sort: {
        prop: '',
        order: ''
      },
      timerange2: '',
      loading: false,
      findform: {
        data_val: ''
      },
      formItem: {
        // 年份
        startYear: '1889',
        endYear: nowDayObj.year().toString(),
        // 性别
        gender: '1',
        // 模式
        calendarModel: '阳历',
        // 时间类型
        timeType: '2',

        // 出生地经度
        birth_longitude: 113.03940774487,

        // 城市选择器
        cascaderData: cityData,
        cascaderValue: ['43', '4301', '430102'],

        // 年份
        yearValue: nowDayObj.year().toString(),
        // 月份
        monthValue: nowDayObj.month() + 1,
        // 日
        dayValue: nowDayObj.date(),
        // 时
        hourValue: nowDayObj.hour(),
        // 分
        minuteValue: nowDayObj.minute(),

        // 运程索引
        haulIndex: 0,
        // 流年索引
        liuNianIndex: 0
      },

      //= ============
      share: {
        open: false,
        url: '',
        experience: ''
      },
      isbj: false,
      // 奇门
      qimenVar: {
        outstr: [],
        bashen: {},
        diPanTianGan: {}, // 地盘地支
        bamen: {}, // 八门
        jiuxing: {},
        tianPanTianGan: {},
        leftTianGan: {},
        kongWang: {},
        jiju: '',
        zhifu: '',
        jieqi: '',
        yuan: '',
        zhifustr: '',
        zhishistr: ''
      },

      monthList: createList(12),
      dayList: createList(31),
      hourList: createList(23, 0),
      minuteList: createList(59, 0),
      calendarList: [
        {
          value: '阳历',
          label: '阳历'
        },
        {
          value: '农历',
          label: '农历'
        }
      ],

      // 北京时间
      beijingTime: {},
      // 平太阳时
      meanSolarTime: {},
      // 真太阳时
      sunSolarTime: {},

      // 数据集
      dataSet: {
        bazi: {},
        lunar: {},
        nayin: {},
        wuxing: {},
        tiangan: {},
        dizhi: {},
        dizhizanggan: {},
        dishi: {},
        tianganshishen: {},
        dizhishishen: {},
        qiyun: {},
        taiyuan: '',
        minggong: '',
        shengong: '',
        dayun: {},
        liuNian: [],
        xiaoYun: [],
        liuYue: [],
        xun: [],
        xunKong: []
      },

      // 弹出模块
      modelVar: {
        index: '',
        display: false,
        birth_social: [],
        birth_lock: {},
        now_social: [],
        now_lock: {}
      },
      oneagent: Object,
      // 预测图
      predictedMap: [[], [], [], [], [], []],
      predictedBall: {
        year: -1,
        month: -1,
        day: -1,
        time: -1
      },

      // 输入参数
      add_disabled: false,
      subtract_disabled: false,
      number0: 0,
      number1: 0,
      number2: 0,
      number3: 0,
      number4: 0,
      number5: 0,
      createVar: {
        0: {
          birth: [],
          now: []
        },
        1: {
          birth: [],
          now: []
        },
        2: {
          birth: [],
          now: []
        },
        3: {
          birth: [],
          now: []
        },
        4: {
          birth: [],
          now: []
        },
        5: {
          birth: [],
          now: []
        }
      },

      collapse_unfold: ['1'],

      // 出生
      birthChecked: {},
      nowChecked: {},

      // 提交表单
      submitForm: {
        switch: false,
        luck: '',
        sex: '',
        timerange: [],
        chuxing: '',
        caiyun: '',
        ganqing: '',
        qingxu: '',
        shangwuqiatan: '',
        yuerenqiujian: '',
        gongzuoyiji: '',
        renshiguanxi: '',
        qiuxuekaoyun: '',
        xiuzaobanjia: '',
        qiaozibeyun: '',
        bjtype: '',
        bjrange: '',
        bjcontent: '',
        bjth: '',
        taohualianqing: ''
      }
    }
  },

  mounted () {
    this.onPredicted()
    this.submitPredicted()
    this.getTableData()
  },

  methods: {
    /**
     * 确定提交表单
     * @return {[type]} [description]
     */
    getTableData () {
      let query = {
        pageIndex: this.page.current,
        pageSize: this.page.size,
        sortBy: this.sort.prop,
        descending: this.sort.order === 'descending',
        filter: this.findform
      }
      agentService.getAgentPagedListDcsj(query).then(data => {
        this.tableData = data.rows
        this.page.total = data.totalCount
      })
    },
    handleChange (val) {
      if (val == '替换') {
        this.isbj = true
      } else {
        this.isbj = false
      }
    },
    getinfo1: function (name) {
      if (name == '对冲球') {
        this.resetBirth()

        this.submitForm.luck = ''
        this.submitForm.sex = ''
        this.submitForm.chuxing = ''
        this.submitForm.caiyun = ''
        this.submitForm.ganqing = ''
        this.submitForm.qingxu = ''
        this.submitForm.shangwuqiatan = ''
        this.submitForm.yuerenqiujian = ''
        this.submitForm.gongzuoyiji = ''
        this.submitForm.renshiguanxi = ''
        this.submitForm.qiuxuekaoyun = ''
        this.submitForm.xiuzaobanjia = ''
        this.submitForm.qiaozibeyun = ''
        this.submitForm.taohualianqing = ''
        this.oneagent = Object

        this.submitForm.timerange = []
      } else if (name == '搜索') {
        this.getTableData()
      }
    },

    handleSearchFormSubmit () {
      this.getTableData()
    },
    handleSearchFormReset () {
      this.$refs.searchForm.resetFields()
    },
    handleSelectionChange (val) {
      this.multipleSelection = val
    },
    handleSortChange (val) {
      this.sort.prop = val.prop
      this.sort.order = val.order
      this.getTableData()
    },
    handleSizeChange (val) {
      this.page.size = val
      this.getTableData()
    },
    handleCurrentChange (val) {
      this.page.current = val
      this.getTableData()
    },
    dateChangebirthday1 (val) {
      this.timerange2 = val
    },
    submitBj () {
      if (this.submitForm.bjrange == '') {
        this.$Message.error({
          background: true,
          content: '请选择一键编辑范围'
        })
        return
      }
      if (this.submitForm.bjtype == '') {
        this.$Message.error({
          background: true,
          content: '请选择一键编辑选择类型'
        })
        return
      }

      if (this.submitForm.bjtype == '替换') {
        if (this.submitForm.bjth == '') {
          this.$Message.error({
            background: true,
            content: '请填写一键编辑需替换内容'
          })
          return
        } else {
          this.submitForm.chuxing = this.submitForm.chuxing.replaceAll(this.submitForm.bjth, this.submitForm.bjcontent)
          this.submitForm.caiyun = this.submitForm.caiyun.replaceAll(this.submitForm.bjth, this.submitForm.bjcontent)
          this.submitForm.ganqing = this.submitForm.ganqing.replaceAll(this.submitForm.bjth, this.submitForm.bjcontent)
          this.submitForm.qingxu = this.submitForm.qingxu.replaceAll(this.submitForm.bjth, this.submitForm.bjcontent)
          this.submitForm.shangwuqiatan = this.submitForm.shangwuqiatan.replaceAll(this.submitForm.bjth, this.submitForm.bjcontent)
          this.submitForm.yuerenqiujian = this.submitForm.yuerenqiujian.replaceAll(this.submitForm.bjth, this.submitForm.bjcontent)
          this.submitForm.gongzuoyiji = this.submitForm.gongzuoyiji.replaceAll(this.submitForm.bjth, this.submitForm.bjcontent)
          this.submitForm.renshiguanxi = this.submitForm.renshiguanxi.replaceAll(this.submitForm.bjth, this.submitForm.bjcontent)
          this.submitForm.qiuxuekaoyun = this.submitForm.qiuxuekaoyun.replaceAll(this.submitForm.bjth, this.submitForm.bjcontent)
          this.submitForm.xiuzaobanjia = this.submitForm.xiuzaobanjia.replaceAll(this.submitForm.bjth, this.submitForm.bjcontent)
          this.submitForm.qiaozibeyun = this.submitForm.qiaozibeyun.replaceAll(this.submitForm.bjth, this.submitForm.bjcontent)
          this.submitForm.taohualianqing = this.submitForm.taohualianqing.replaceAll(this.submitForm.bjth, this.submitForm.bjcontent)
        }
      } else {
        if (this.submitForm.bjcontent == '') {
          this.$Message.error({
            background: true,
            content: '请填写一键编辑内容'
          })
          return
        }
        if (this.submitForm.bjtype == '文字前') {
          this.submitForm.chuxing = this.submitForm.bjcontent + this.submitForm.chuxing
          this.submitForm.caiyun = this.submitForm.bjcontent + this.submitForm.caiyun
          this.submitForm.ganqing = this.submitForm.bjcontent + this.submitForm.ganqing
          this.submitForm.qingxu = this.submitForm.bjcontent + this.submitForm.qingxu
          this.submitForm.shangwuqiatan = this.submitForm.bjcontent + this.submitForm.shangwuqiatan
          this.submitForm.yuerenqiujian = this.submitForm.bjcontent + this.submitForm.yuerenqiujian
          this.submitForm.gongzuoyiji = this.submitForm.bjcontent + this.submitForm.gongzuoyiji
          this.submitForm.renshiguanxi = this.submitForm.bjcontent + this.submitForm.renshiguanxi
          this.submitForm.qiuxuekaoyun = this.submitForm.bjcontent + this.submitForm.qiuxuekaoyun
          this.submitForm.xiuzaobanjia = this.submitForm.bjcontent + this.submitForm.xiuzaobanjia
          this.submitForm.qiaozibeyun = this.submitForm.bjcontent + this.submitForm.qiaozibeyun
          this.submitForm.taohualianqing = this.submitForm.bjcontent + this.submitForm.taohualianqing
        } else if (this.submitForm.bjtype == '文字后') {
          this.submitForm.chuxing = this.submitForm.chuxing + this.submitForm.bjcontent
          this.submitForm.caiyun = this.submitForm.caiyun + this.submitForm.bjcontent
          this.submitForm.ganqing = this.submitForm.ganqing + this.submitForm.bjcontent
          this.submitForm.qingxu = this.submitForm.qingxu + this.submitForm.bjcontent
          this.submitForm.shangwuqiatan = this.submitForm.shangwuqiatan + this.submitForm.bjcontent
          this.submitForm.yuerenqiujian = this.submitForm.yuerenqiujian + this.submitForm.bjcontent
          this.submitForm.gongzuoyiji = this.submitForm.gongzuoyiji + this.submitForm.bjcontent
          this.submitForm.renshiguanxi = this.submitForm.renshiguanxi + this.submitForm.bjcontent
          this.submitForm.qiuxuekaoyun = this.submitForm.qiuxuekaoyun + this.submitForm.bjcontent
          this.submitForm.xiuzaobanjia = this.submitForm.xiuzaobanjia + this.submitForm.bjcontent
          this.submitForm.qiaozibeyun = this.submitForm.qiaozibeyun + this.submitForm.bjcontent
          this.submitForm.taohualianqing = this.submitForm.taohualianqing + this.submitForm.bjcontent
        }
      }

      if (this.submitForm.bjrange == '所有数据编辑') {
        let msg = '是否更新所有数据'
        this.$confirm('确认' + msg + '操作？', '确认信息', {
          distinguishCancelAndClose: true,
          confirmButtonText: msg,
          cancelButtonText: '取消'
        }).then(() => {
          this.submitAll()
        })
      }
    },
    submitAll () {
      var one_val = this.createVar[0].birth.length + this.createVar[0].now.length
      var two_val = this.createVar[1].birth.length + this.createVar[1].now.length
      var three_val = this.createVar[2].birth.length + this.createVar[2].now.length
      var six_val = this.createVar[3].birth.length + this.createVar[3].now.length
      var five_val = this.createVar[4].birth.length + this.createVar[4].now.length
      var four_val = this.createVar[5].birth.length + this.createVar[5].now.length

      this.$Modal.confirm({
        title: '提交表单',
        content: '',
        onOk: () => {
          // this.$Message.info("提交成功");
          if (this.oneagent.id) {
            agentService.saveSjrr({
              ...this.submitForm,
              one_val: one_val,
              id: this.oneagent.id,
              two_val: two_val,
              three_val: three_val,
              four_val: four_val,
              five_val: five_val,
              six_val: six_val,
              timerange2: this.timerange2
            })
              .then(data => {
                this.loading = false

                this.getTableData()
              })
          } else {
            agentService.saveSjrr({
              ...this.submitForm,
              one_val: one_val,
              two_val: two_val,
              three_val: three_val,
              four_val: four_val,
              five_val: five_val,
              six_val: six_val,
              timerange2: this.timerange2
            })
              .then(data => {
                this.loading = false
                this.getTableData()
              })
          }
        },
        onCancel: () => {
          // this.$Message.info('Clicked cancel');
        }
      })
    },

    // 改变出生经度
    changeLongitude (e) {
      this.formItem.cascaderValue = []
    },

    // 重置时辰球
    resetBirth () {
      this.modelVar.birth_social = []
      this.birthChecked = {}
      this.modelVar.birth_lock = []
      for (let key in this.createVar) {
        this.createVar[key]['birth'] = []
      }
    },

    resetNow () {
      this.modelVar.now_social = []
      this.nowChecked = {}
      this.modelVar.now_lock = []
      for (let key in this.createVar) {
        this.createVar[key]['now'] = []
      }
    },

    changeSwitch (e) {
      if (e == true) {
        this.collapse_unfold = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12']
      } else {
        this.collapse_unfold = ['1']
      }
    },

    changeModal (index) {
      this.modelVar.index = index
      this.modelVar.display = true
      this.modelVar.birth_social = []
      this.modelVar.now_social = []

      let total = 0
      for (let key in this.createVar) {
        let item = this.createVar[key]
        if (item.birth) {
          total += item.birth.length
        }
        if (item.now) {
          total += item.now.length
        }
      }

      if (total > 0) {
        for (let key in this.createVar) {
          let item = this.createVar[key]
          if (item.birth) {
            if (this.modelVar.index == key) {
              this.modelVar.birth_social = item.birth
              item.birth.forEach((item) => {
                this.modelVar.birth_lock[item] = false
              })
            } else {
              item.birth.forEach((item) => {
                this.modelVar.birth_lock[item] = true
              })
            }
          }

          if (item.now) {
            if (this.modelVar.index == key) {
              this.modelVar.now_social = item.now
              item.now.forEach((item) => {
                this.modelVar.now_lock[item] = false
              })
            } else {
              item.now.forEach((item) => {
                this.modelVar.now_lock[item] = true
              })
            }
          }
        }
      }
    },

    setChecked () {
      let birthChecked = {}
      let nowChecked = {}
      for (let key in this.createVar) {
        let item = this.createVar[key]
        if (item.birth && item.birth.length) {
          item.birth.forEach((b) => {
            birthChecked[b] = true
          })
        }
        if (item.now && item.now.length) {
          item.now.forEach((b) => {
            nowChecked[b] = true
          })
        }
      }
      this.birthChecked = birthChecked
      this.nowChecked = nowChecked
    },
    openEditForm (oneagent) {
      this.createVar[0]['birth'] = []
      this.createVar[1]['birth'] = []
      this.createVar[2]['birth'] = []
      this.createVar[3]['birth'] = []
      this.createVar[4]['birth'] = []
      this.createVar[5]['birth'] = []
      this.oneagent = oneagent
      if (oneagent.data_val.substr(0, 1) > 0) {
        if (oneagent.data_val.substr(0, 1) == 1) {
          this.createVar[0]['birth'] = oneagent.data_val.substr(0, 1)
        } else if (oneagent.data_val.substr(0, 1) == 2) {
          this.createVar[0]['birth'] = '11'
        } else if (oneagent.data_val.substr(0, 1) == 3) {
          this.createVar[0]['birth'] = '111'
        } else if (oneagent.data_val.substr(0, 1) == 4) {
          this.createVar[0]['birth'] = '1111'
        } else if (oneagent.data_val.substr(0, 1) == 5) {
          this.createVar[0]['birth'] = '11111'
        } else if (oneagent.data_val.substr(0, 1) == 6) {
          this.createVar[0]['birth'] = '111111'
        } else if (oneagent.data_val.substr(0, 1) == 7) {
          this.createVar[0]['birth'] = '1111111'
        } else if (oneagent.data_val.substr(0, 1) == 8) {
          this.createVar[0]['birth'] = '11111111'
        }
      }
      if (oneagent.data_val.substr(1, 1) > 0) {
        if (oneagent.data_val.substr(1, 1) == 1) {
          this.createVar[1]['birth'] = oneagent.data_val.substr(1, 1)
        } else if (oneagent.data_val.substr(1, 1) == 2) {
          this.createVar[1]['birth'] = '11'
        } else if (oneagent.data_val.substr(1, 1) == 3) {
          this.createVar[1]['birth'] = '111'
        } else if (oneagent.data_val.substr(1, 1) == 4) {
          this.createVar[1]['birth'] = '1111'
        } else if (oneagent.data_val.substr(1, 1) == 5) {
          this.createVar[1]['birth'] = '11111'
        } else if (oneagent.data_val.substr(1, 1) == 6) {
          this.createVar[1]['birth'] = '111111'
        } else if (oneagent.data_val.substr(1, 1) == 7) {
          this.createVar[1]['birth'] = '1111111'
        } else if (oneagent.data_val.substr(1, 1) == 8) {
          this.createVar[1]['birth'] = '11111111'
        }
      }
      if (oneagent.data_val.substr(2, 1) > 0) {
        if (oneagent.data_val.substr(2, 1) == 1) {
          this.createVar[2]['birth'] = oneagent.data_val.substr(2, 1)
        } else if (oneagent.data_val.substr(2, 1) == 2) {
          this.createVar[2]['birth'] = '11'
        } else if (oneagent.data_val.substr(2, 1) == 3) {
          this.createVar[2]['birth'] = '111'
        } else if (oneagent.data_val.substr(2, 1) == 4) {
          this.createVar[2]['birth'] = '1111'
        } else if (oneagent.data_val.substr(2, 1) == 5) {
          this.createVar[2]['birth'] = '11111'
        } else if (oneagent.data_val.substr(2, 1) == 6) {
          this.createVar[2]['birth'] = '111111'
        } else if (oneagent.data_val.substr(2, 1) == 7) {
          this.createVar[2]['birth'] = '1111111'
        } else if (oneagent.data_val.substr(2, 1) == 8) {
          this.createVar[2]['birth'] = '11111111'
        }
      }
      if (oneagent.data_val.substr(3, 1) > 0) {
        if (oneagent.data_val.substr(3, 1) == 1) {
          this.createVar[5]['birth'] = oneagent.data_val.substr(3, 1)
        } else if (oneagent.data_val.substr(3, 1) == 2) {
          this.createVar[5]['birth'] = '11'
        } else if (oneagent.data_val.substr(3, 1) == 3) {
          this.createVar[5]['birth'] = '111'
        } else if (oneagent.data_val.substr(3, 1) == 4) {
          this.createVar[5]['birth'] = '1111'
        } else if (oneagent.data_val.substr(3, 1) == 5) {
          this.createVar[5]['birth'] = '11111'
        } else if (oneagent.data_val.substr(3, 1) == 6) {
          this.createVar[5]['birth'] = '111111'
        } else if (oneagent.data_val.substr(3, 1) == 7) {
          this.createVar[5]['birth'] = '1111111'
        } else if (oneagent.data_val.substr(3, 1) == 8) {
          this.createVar[5]['birth'] = '11111111'
        }
      }
      if (oneagent.data_val.substr(4, 1) > 0) {
        if (oneagent.data_val.substr(4, 1) == 1) {
          this.createVar[4]['birth'] = oneagent.data_val.substr(4, 1)
        } else if (oneagent.data_val.substr(4, 1) == 2) {
          this.createVar[4]['birth'] = '11'
        } else if (oneagent.data_val.substr(4, 1) == 3) {
          this.createVar[4]['birth'] = '111'
        } else if (oneagent.data_val.substr(4, 1) == 4) {
          this.createVar[4]['birth'] = '1111'
        } else if (oneagent.data_val.substr(4, 1) == 5) {
          this.createVar[4]['birth'] = '11111'
        } else if (oneagent.data_val.substr(4, 1) == 6) {
          this.createVar[4]['birth'] = '111111'
        } else if (oneagent.data_val.substr(4, 1) == 7) {
          this.createVar[4]['birth'] = '1111111'
        } else if (oneagent.data_val.substr(4, 1) == 8) {
          this.createVar[4]['birth'] = '11111111'
        }
      }
      if (oneagent.data_val.substr(5, 1) > 0) {
        if (oneagent.data_val.substr(5, 1) == 1) {
          this.createVar[3]['birth'] = oneagent.data_val.substr(5, 1)
        } else if (oneagent.data_val.substr(5, 1) == 2) {
          this.createVar[3]['birth'] = '11'
        } else if (oneagent.data_val.substr(5, 1) == 3) {
          this.createVar[3]['birth'] = '111'
        } else if (oneagent.data_val.substr(5, 1) == 4) {
          this.createVar[3]['birth'] = '1111'
        } else if (oneagent.data_val.substr(5, 1) == 5) {
          this.createVar[3]['birth'] = '11111'
        } else if (oneagent.data_val.substr(5, 1) == 6) {
          this.createVar[3]['birth'] = '111111'
        } else if (oneagent.data_val.substr(5, 1) == 7) {
          this.createVar[3]['birth'] = '1111111'
        } else if (oneagent.data_val.substr(5, 1) == 8) {
          this.createVar[3]['birth'] = '11111111'
        }
      }
      this.submitForm.luck = oneagent.luck
      this.submitForm.sex = oneagent.sex
      this.submitForm.chuxing = oneagent.chuxing
      this.submitForm.caiyun = oneagent.caiyun
      this.submitForm.ganqing = oneagent.ganqing
      this.submitForm.qingxu = oneagent.qingxu
      this.submitForm.shangwuqiatan = oneagent.shangwuqiatan
      this.submitForm.yuerenqiujian = oneagent.yuerenqiujian
      this.submitForm.gongzuoyiji = oneagent.gongzuoyiji
      this.submitForm.renshiguanxi = oneagent.renshiguanxi
      this.submitForm.qiuxuekaoyun = oneagent.qiuxuekaoyun
      this.submitForm.xiuzaobanjia = oneagent.xiuzaobanjia
      this.submitForm.qiaozibeyun = oneagent.qiaozibeyun
      this.submitForm.taohualianqing = oneagent.taohualianqing

      this.submitForm.timerange = [oneagent.start_time, oneagent.end_time]
    },

    delEditForm (oneagent) {
      let msg = '删除'
      this.$confirm('确认' + msg + '操作？', '确认信息', {
        distinguishCancelAndClose: true,
        confirmButtonText: msg,
        cancelButtonText: '取消'
      }).then(() => {
        agentService.delSjrr({ id: oneagent.id }).then(() => {
          this.getTableData()
        })
      })
    },

    // 出生时辰选项
    birthGroupChange (data) {
      this.createVar[this.modelVar.index]['birth'] = data
      this.setChecked()
    },

    nowGroupChange (data) {
      this.createVar[this.modelVar.index]['now'] = data
      this.setChecked()
    },

    /**
     * 获取选择地区的名字
     */
    onGetCityName (value, selectedData) {
      const data = coordinateData[value[value.length - 1]]
      if (data) {
        this.formItem.birth_longitude = data.longitude
      }
    },

    getIndex (index) {
      index = index + 1
      if (index == 4) {
        return 6
      }
      if (index == 6) {
        return 4
      }
      return index
    },

    getStartYear (data) {
      this.formItem.startYear = data
      if (!this.formItem.endYear) {
        this.$Message.error({
          background: true,
          content: '请先设置截止年份'
        })
      }
      this.onPredicted()
    },
    getEndYear (data) {
      this.formItem.endYear = data
      if (!this.formItem.startYear) {
        this.$Message.error({
          background: true,
          content: '请先设置开始年份'
        })
      }
      this.onPredicted()
    },

    //= ===================
    //   获取出生时辰值
    //= ===================

    // 设置搜索
    getYearValue (value) {
      this.formItem.yearValue = value
    },
    getMonthValue (value) {
      this.formItem.monthValue = value
    },
    getDayValue (value) {
      this.formItem.dayValue = value
    },
    getHourValue (value) {
      this.formItem.hourValue = value
    },
    getMinuteValue (value) {
      this.formItem.minuteValue = value
    },

    //= ===================
    //   创建年份分布图
    //= ===================
    onPredicted () {
      let yearMap = []
      for (var i = this.formItem.startYear; i <= this.formItem.endYear; i++) {
        yearMap.push(Number(i))
      }
      let index = 0
      let result = [[], [], [], [], [], []]
      for (var i = 0, len = yearMap.length; i < len; i++) {
        result[index].push(yearMap[i])
        if (index >= 5) {
          index = 0
        } else {
          index++
        }
      }
      this.predictedMap = [
        result[0],
        result[1],
        result[2],
        result[5],
        result[4],
        result[3]
      ]
      let map = result.map((item) => item[0])
      this.originalPredictedMap = map
      this.diffPredictedMap = []
        .concat(map)
        .concat(map)
        .concat(map)
        .concat(map)
        .concat(map)
        .concat(map)
        .concat(map)
        .concat(map)

      this.matchPredictedMap = {}
      this.predictedMap.map((item, index) => {
        this.matchPredictedMap[item[0]] = index
      })
    },

    /**
     * 切换运程
     * @return {[type]} [description]
     */
    changeHaul (index) {
      this.formItem.haulIndex = index
      const daYunObj = this.dataSet.dayun.daYunArr[index]
      if (daYunObj.getLiuNian) {
        this.dataSet.liuNian = daYunObj.getLiuNian()
      }
      this.dataSet.xiaoYun = daYunObj.getXiaoYun()
      this.changeLiuNian(0)
    },

    /**
     * 切换流年
     * 变化流月
     * @return {[type]} [description]
     */
    changeLiuNian (index) {
      this.formItem.liuNianIndex = index
      let liuNianObj = this.dataSet.liuNian[index]
      if (liuNianObj && liuNianObj.getLiuYue) {
        this.dataSet.liuYue = liuNianObj.getLiuYue()
      }
    },

    //= ===================
    //   开始预测数据
    //= ===================

    // 设置北京时间
    setBeiJingTime (data) {
      let { year, month, day, hour, minute } = data
      let full = `${year}年${month}月${day}日${hour}时${minute}分`
      this.beijingTime = { year, month, day, hour, minute, full }
    },

    // 设置平太阳时
    setMeanSolarTime (data) {
      //= ==================
      //  真太阳时计算
      //= ==================
      let beijing_longitude = 120
      // 1度相差4分钟
      let degree

      // 符号
      let sign
      const birth_longitude =
        Math.round(parseFloat(this.formItem.birth_longitude) * 100) / 100
      // 小于120经度
      if (birth_longitude < beijing_longitude) {
        sign = 'subtract'
        degree = floatSub(beijing_longitude, birth_longitude)
      } else {
        sign = 'add'
        degree = floatSub(birth_longitude, beijing_longitude)
      }
      // console.log(degree, sign);

      // 平太阳时 ＝北京时间+[(当地经度－120) ×4分钟]
      // 24小时       360度
      // 1小时        15度
      // 4分钟         1度
      // 1分钟         15分
      // 4秒           1分
      // /(\d+)\.*(\d*)/
      let degree_reg = degree.toString().match(/(\d+)\.*(\d*)/)
      let meanSolarDiff_Minute = degree_reg[1] * 4 // 分
      let meanSolarDiff_Second = Number(degree_reg[2]) * 2 // 秒

      // 北京时间格式化
      let beijing_format = dayjs(
        `${data.year}-${data.month}-${data.day} ${data.hour}:${data.minute}`
      )

      //= ============================
      //         平太阳时
      //= ============================
      let newMeanDate = beijing_format[sign](meanSolarDiff_Minute, 'minute')[
        sign
      ](meanSolarDiff_Second, 'second')

      let meanYearValue = newMeanDate.year()
      let meanMonthValue = newMeanDate.month() + 1
      let meanDayValue = newMeanDate.date()
      let meanHourValue = newMeanDate.hour()
      let meanMinuteValue = newMeanDate.minute()

      return (this.meanSolarTime = {
        year: meanYearValue,
        month: meanMonthValue,
        day: meanDayValue,
        hour: meanHourValue,
        minute: meanMinuteValue,
        meanObj: newMeanDate,
        full: `${meanYearValue}年${meanMonthValue}月${meanDayValue}日${meanHourValue}时${meanMinuteValue}分`
      })
    },

    // 设置真太阳时
    setApparentSolarTime (meanSolarData) {
      // 真太阳时
      let diff_time = `${meanSolarData.month}月${meanSolarData.day}日`
      let reg = new RegExp(diff_time + '([+-])(\\d+)分(\\d+)秒', 'mi')
      let regRet = dateDiffStr.match(reg)
      let regSymbol = regRet[1]
      let regMinuteValue = regRet[2]
      let regSecondValue = regRet[3]
      let sunDateData
      if (regSymbol == '+') {
        sunDateData = meanSolarData.meanObj
          .add(regMinuteValue, 'minute')
          .add(regSecondValue, 'second')
      } else {
        sunDateData = meanSolarData.meanObj
          .subtract(regMinuteValue, 'minute')
          .subtract(regSecondValue, 'second')
      }

      // 用真太阳时做实际计算时间
      let sunYearValue = sunDateData.year()
      let sunMonthValue = sunDateData.month() + 1
      let sunDayValue = sunDateData.date()
      let sunHourValue = sunDateData.hour()
      let sunMnuteValue = sunDateData.minute()

      return (this.sunSolarTime = {
        year: sunYearValue,
        month: sunMonthValue,
        day: sunDayValue,
        hour: sunHourValue,
        minute: sunMnuteValue,
        full: `${sunYearValue}年${sunMonthValue}月${sunDayValue}日${sunHourValue}时${sunMnuteValue}分`
      })
    },

    submitPredicted () {
      if (!this.diffPredictedMap) {
        this.$Message.error({
          background: true,
          content: '先请生成年份图'
        })
        return
      }

      if (!this.formItem.gender) {
        this.$Message.error({
          background: true,
          content: '请先设置性别'
        })
        return
      }

      // 真太阳时起局
      if (this.formItem.timeType == 2) {
        if (!this.formItem.birth_longitude) {
          this.$Message.error({
            background: true,
            content: '请先设置出生地点'
          })
          return
        }
      }

      let deffMap = this.diffPredictedMap
      let input_yearValue = Number(this.formItem.yearValue)
      let input_monthValue = Number(this.formItem.monthValue)
      let input_dayValue = Number(this.formItem.dayValue)
      let input_hourValue = Number(this.formItem.hourValue)
      let input_minuteValue = Number(this.formItem.minuteValue)

      // 如果是0点，加一天
      if (input_hourValue == 23) {
        let newDayjs = dayjs(
          `${input_yearValue}-${input_monthValue}-${input_dayValue} ${input_hourValue}:${input_minuteValue}:0`
        )
        newDayjs = newDayjs.add(1, 'hour')
        input_yearValue = newDayjs.year()
        input_monthValue = newDayjs.month() + 1
        input_dayValue = newDayjs.date()
        input_hourValue = newDayjs.hour()
        input_minuteValue = newDayjs.minute()
        // console.log(input_yearValue,input_monthValue,input_dayValue,input_hourValue,input_minuteValue)
      }

      if (!(input_yearValue && input_monthValue && input_dayValue)) {
        this.$Message.error({
          background: true,
          content: '先请输入出生日期'
        })
        return
      }

      // 当前时间对象
      let nowDayObj = dayjs()
      // 农历对象
      let lunarObj
      // 阳历对象
      let solarObj
      // 农历测算时间
      let lunarYearValue
      let lunarMonthValue
      let lunarDayValue
      let lunarHourValue
      let lunarMnuteValue

      // 阳历
      let solarYearValue
      let solarMonthValue
      let solarDayValue
      let solarHourValue
      let solarMnuteValue

      this.sunSolarTime = ''
      this.beijingTime = ''
      this.meanSolarTime = ''

      // 如果选的是阳历
      if (this.formItem.calendarModel == '阳历') {
        // 输入时间
        this.setBeiJingTime({
          year: input_yearValue,
          month: input_monthValue,
          day: input_dayValue,
          hour: input_hourValue,
          minute: input_minuteValue
        })

        // 通过阳历转化时间
        // 1 北京时间
        // 2 经度转化阳历时间

        // 北京时间
        if (this.formItem.timeType == 1) {
          solarYearValue = input_yearValue
          solarMonthValue = input_monthValue
          solarDayValue = input_dayValue
          solarHourValue = input_hourValue
          solarMnuteValue = input_minuteValue
        } else {
          // 平太阳时
          const meanSolarData = this.setMeanSolarTime({
            year: input_yearValue,
            month: input_monthValue,
            day: input_dayValue,
            hour: input_hourValue,
            minute: input_minuteValue
          })
          // 真太阳时
          const apparentSolarData = this.setApparentSolarTime(meanSolarData)
          solarYearValue = apparentSolarData.year
          solarMonthValue = apparentSolarData.month
          solarDayValue = apparentSolarData.day
          solarHourValue = apparentSolarData.hour
          solarMnuteValue = apparentSolarData.minute
        }

        // 阳历
        solarObj = baziUtils.Solar.fromYmdHms(
          solarYearValue,
          solarMonthValue,
          solarDayValue,
          solarHourValue,
          solarMnuteValue,
          0
        )
        // 农历
        lunarObj = solarObj.getLunar()
        lunarYearValue = lunarObj.getYear()
        lunarMonthValue = lunarObj.getMonth()
        lunarDayValue = lunarObj.getDay()
        lunarHourValue = input_hourValue
        lunarMnuteValue = input_minuteValue
      }

      // 如果是农历
      if (this.formItem.calendarModel == '农历') {
        // 农历对象
        lunarObj = baziUtils.Lunar.fromYmdHms(
          input_yearValue,
          input_monthValue,
          input_dayValue,
          input_hourValue,
          input_minuteValue,
          0
        )
        lunarYearValue = input_yearValue
        lunarMonthValue = input_monthValue
        lunarDayValue = input_dayValue
        lunarHourValue = input_hourValue
        lunarMnuteValue = input_minuteValue

        // 阳历对象
        solarObj = lunarObj.getSolar()
        solarYearValue = solarObj.getYear()
        solarMonthValue = solarObj.getMonth()
        solarDayValue = solarObj.getDay()
        solarHourValue = input_hourValue
        solarMnuteValue = input_minuteValue

        // 北京时间
        this.setBeiJingTime({
          year: solarYearValue,
          month: solarMonthValue,
          day: solarDayValue,
          hour: solarHourValue,
          minute: solarMnuteValue
        })

        // 真太阳时
        if (this.formItem.timeType == 2) {
          const meanSolarData = this.setMeanSolarTime({
            year: solarYearValue,
            month: solarMonthValue,
            day: solarDayValue,
            hour: solarHourValue,
            minute: solarMnuteValue
          })
          const apparentSolarData = this.setApparentSolarTime(meanSolarData)
          solarYearValue = apparentSolarData.year
          solarMonthValue = apparentSolarData.month
          solarDayValue = apparentSolarData.day
          solarHourValue = apparentSolarData.hour
          solarMnuteValue = apparentSolarData.minute
        }
      }

      //= ===============================
      //        八字排盘
      //= ===============================

      // 八字对象
      const baziObj = lunarObj.getEightChar()

      //= ============================
      //          八字
      //= ============================
      this.dataSet.bazi = {
        year: baziObj.getYear(),
        month: baziObj.getMonth(),
        day: baziObj.getDay(),
        hour: baziObj.getTime()
      }

      //= ============================
      //          五行
      //= ============================
      this.dataSet.wuxing = {
        year: baziObj.getYearWuXing(),
        month: baziObj.getMonthWuXing(),
        day: baziObj.getDayWuXing(),
        hour: baziObj.getTimeWuXing()
      }

      //= ============================
      //       天干
      //= ============================
      this.dataSet.tiangan = {
        year: baziObj.getYearGan(),
        month: baziObj.getMonthGan(),
        day: baziObj.getDayGan(),
        hour: baziObj.getTimeGan()
      }

      //= ============================
      //       天干十神
      //= ============================
      this.dataSet.tianganshishen = {
        year: baziObj.getYearShiShenGan(),
        month: baziObj.getMonthShiShenGan(),
        day: baziObj.getDayShiShenGan(),
        hour: baziObj.getTimeShiShenGan()
      }

      //= ============================
      //       地支
      //= ============================
      this.dataSet.dizhi = {
        year: baziObj.getYearZhi(),
        month: baziObj.getMonthZhi(),
        day: baziObj.getDayZhi(),
        hour: baziObj.getTimeZhi()
      }

      //= ============================
      //       地支十神
      //= ============================
      this.dataSet.dizhishishen = {
        year: baziObj.getYearShiShenZhi(),
        month: baziObj.getMonthShiShenZhi(),
        day: baziObj.getDayShiShenZhi(),
        hour: baziObj.getTimeShiShenZhi()
      }

      //= ============================
      //       地支臧干
      //= ============================
      this.dataSet.dizhizanggan = {
        year: baziObj.getYearHideGan(),
        month: baziObj.getMonthHideGan(),
        day: baziObj.getDayHideGan(),
        hour: baziObj.getTimeHideGan()
      }

      //= ============================
      //       地势
      //= ============================
      this.dataSet.dishi = {
        year: baziObj.getYearDiShi(),
        month: baziObj.getMonthDiShi(),
        day: baziObj.getDayDiShi(),
        hour: baziObj.getTimeDiShi()
      }

      //= ============================
      //      旬
      //= ============================
      this.dataSet.xun = {
        year: baziObj.getYearXun(),
        month: baziObj.getMonthXun(),
        day: baziObj.getDayXun(),
        hour: baziObj.getTimeXun()
      }

      //= ============================
      //      旬空
      //= ============================
      this.dataSet.xunKong = {
        year: baziObj.getYearXunKong(),
        month: baziObj.getMonthXunKong(),
        day: baziObj.getDayXunKong(),
        hour: baziObj.getTimeXunKong()
      }

      //= ============================
      //          纳音
      //= ============================
      this.dataSet.nayin = {
        year: lunarObj.getYearNaYin(),
        month: lunarObj.getMonthNaYin(),
        day: lunarObj.getDayNaYin(),
        hour: lunarObj.getTimeNaYin()
      }

      //= ============================
      //          农历
      //= ============================
      console.log('lunarObj', lunarObj)
      this.dataSet.lunar = {
        year: lunarYearValue,
        month: lunarMonthValue,
        day: lunarDayValue,
        hour: lunarHourValue,
        yearcn: lunarObj.getYearInChinese(),
        monthcn: lunarObj.getMonthInChinese(),
        daycn: lunarObj.getDayInChinese(),
        week: `星期${lunarObj.getWeekInChinese()}`
      }
      this.dataSet.lunar.full = `${this.dataSet.lunar.yearcn}年${this.dataSet.lunar.monthcn}月${this.dataSet.lunar.daycn}日${this.dataSet.lunar.hour}时`
      // 查看当年润了几月
      // 返回农历 y 年闰月是哪个月；若 y 年没有闰月 则返回
      let leapMonth = baziUtils.LunarUtil.getLeapMonth(lunarYearValue)
      if (leapMonth) {
        this.dataSet.lunar.leapMonth = `闰${leapMonth}月`
      }

      //= ============================
      //         胎元
      //= ============================
      this.dataSet.taiyuan = baziObj.getTaiYuan()

      //= ============================
      //         命宫
      //= ============================
      this.dataSet.minggong = baziObj.getMingGong()

      //= ============================
      //         身宫
      //= ============================
      this.dataSet.shengong = baziObj.getShenGong()

      //= ============================
      //          起运
      //= ============================
      // gender(数字)为性别，1为男，0为女
      var qiYun = baziObj.getYun(this.formItem.gender == 2 ? 0 : 1)
      this.dataSet.qiyun = {
        time:
          '出生' +
          qiYun.getStartYear() +
          '年' +
          qiYun.getStartMonth() +
          '个月' +
          qiYun.getStartDay() +
          '天后起运',
        gongli: qiYun.getStartSolar()
      }

      //= ============================
      //          大运
      //= ============================
      var daYunArr = qiYun.getDaYun()
      const nowYear = nowDayObj.year()
      const daYunObjs = daYunArr.filter(function (daYun, index, arr) {
        if (daYun.getStartYear() >= nowYear) {
          return daYun
        }
      })
      const daYunObj = daYunObjs[0]
      const daYunGanZhi = daYunObj.getGanZhi()
      const daYunGanZhiSplit = daYunGanZhi.split('')
      this.dataSet.dayun = {
        daYunArr: daYunArr,
        tiangan: daYunGanZhiSplit[0],
        dizhi: daYunGanZhiSplit[1]
      }

      //= ============================
      //          流年
      //= ============================
      this.changeHaul(0)

      //= ============================
      //          预测图
      //= ============================

      // 农历时间
      let matchFristYear = ''
      let matchFristMonth = ''
      let matchFristDay = ''

      //= ======= 计算年 ========
      this.predictedMap.forEach((item, index) => {
        if (item.find((n) => n == lunarYearValue)) {
          this.predictedBall.year = index
          matchFristYear = item[0]
        }
      })

      //= ======= 计算月 ========
      // 如果闰年,月份落子+1，从润的月份开始+1
      // 如果是闰年，并且当前的月份大于等于闰月
      let lmonthStep = 0
      if (leapMonth && lunarMonthValue >= leapMonth) {
        lmonthStep = 1
      }
      let yearFrontIndex = this.originalPredictedMap.indexOf(matchFristYear)
      let deffYearIndex = lunarMonthValue + lmonthStep
      for (var k = 0; k < deffMap.length; k++) {
        if (k >= yearFrontIndex) {
          deffYearIndex--
        }
        if (deffYearIndex == 0) {
          this.predictedBall.month = this.matchPredictedMap[deffMap[k]]
          matchFristMonth = deffMap[k]
        }
      }

      //= ======= 计算日 ========
      let monthFrontIndex = this.originalPredictedMap.indexOf(matchFristMonth)
      let deffMonthIndex = lunarDayValue
      for (var k = 0; k < deffMap.length; k++) {
        if (k >= monthFrontIndex) {
          deffMonthIndex--
        }
        if (deffMonthIndex == 0) {
          this.predictedBall.day = this.matchPredictedMap[deffMap[k]]
          matchFristDay = deffMap[k]
        }
      }

      //= ======= 计算时 ========
      if (lunarHourValue) {
        // 计算时间
        let dayFrontIndex = this.originalPredictedMap.indexOf(matchFristDay)
        // 0-1早子时，
        // 1-3丑时
        // 3-5寅时
        // 5-7卯时
        // 7-9辰时
        // 9-11巳时
        // 11-13午时
        // 13-15未时
        // 15-17申时
        // 17-19酉时
        // 19-21戌时
        // 21-23亥时
        // 23-24夜子时
        let timeMap = {
          子: 1,
          丑: 2,
          寅: 3,
          卯: 4,
          辰: 5,
          巳: 6,
          午: 7,
          未: 8,
          申: 9,
          酉: 10,
          戌: 11,
          亥: 12
        }

        let ltime = Math.floor((lunarHourValue + 1) / 2)
        let deffDayIndex = timeMap[this.dataSet.dizhi.hour]
        for (var k = 0; k < deffMap.length; k++) {
          if (k >= dayFrontIndex) {
            deffDayIndex--
          }
          if (deffDayIndex == 0) {
            this.predictedBall.time = this.matchPredictedMap[deffMap[k]]
          }
        }
      }

      //= ============================
      //    奇门排盘 按照阳历排盘
      //= ============================
      const jiqi = JIQI.GetJiqiInfo(
        solarYearValue,
        solarMonthValue,
        solarDayValue,
        solarHourValue,
        solarMnuteValue,
        0,
        0
      )

      // 排四柱
      var tcol0 = new Array()
      var dcol0 = new Array()
      for (var i = 6; i > -1; i -= 2) tcol0.push(jiqi.bazi[i])
      for (var i = 7; i > -1; i -= 2) dcol0.push(jiqi.bazi[i])

      let outstr = []
      let str = ''
      outstr.push(JIQI.JTime(jiqi.julian))

      // 农历
      outstr.push(`${this.dataSet.lunar.full}`)

      // 节气
      var cjiqi = jiqi.currentJiqiIdx - 1
      if (cjiqi < 0) cjiqi = 23
      outstr.push(
        SPF.sprintf(
          '%s, %s\r\n',
          jiqi.jiqi[cjiqi],
          JIQI.JTime(jiqi.wholeYear[cjiqi])
        )
      )

      // 計時家奇門三元
      var idx1 = '甲乙丙丁戊己庚辛壬癸'.indexOf(jiqi.bazi[4])
      var idx2 = '子丑寅卯辰巳午未申酉戌亥'.indexOf(jiqi.bazi[5])
      idx2 = idx2 - (idx1 % 5)
      if (idx2 < 0) idx2 += 12
      idx2 = idx2 % 3
      if (idx2 > 0) {
        idx2 = idx2 == 1 ? 2 : 1
      }
      this.qimenVar.jieqi = jiqi.jiqi[cjiqi]
      this.qimenVar.yuan = '上中下'.charAt(idx2) + '元　'

      // 計算當前局數
      // 計陰陽遁
      var dun_type = 2 // 0為陰遁, 1為陽遁, 其餘為錯誤
      var kook = [
        8, 9, 1, 3, 4, 5, 4, 5, 6, 9, 8, 7, 2, 1, 9, 7, 6, 5, 6, 5, 4, 1, 2, 3
      ] // 局數
      var using_kook = kook[cjiqi] // 局數
      // console.log(jtoday, jqTime[21], jqTime[9]);
      if (jiqi.julian > jiqi.wholeYear[9] && jiqi.julian < jiqi.wholeYear[21]) {
        // 陰遁
        dun_type = 0
        for (var i = 0; i < idx2; i++) {
          using_kook -= 6
          while (using_kook < 1) using_kook += 9
        }
      } else {
        // 陽遁
        dun_type = 1
        for (var i = 0; i < idx2; i++) {
          using_kook += 6
          while (using_kook > 9) using_kook -= 9
        }
      }
      str +=
        '阴阳'.charAt(dun_type) +
        '遁' +
        ' 一二三四五六七八九'.charAt(using_kook) +
        '局'
      this.qimenVar.jiju = str

      /** 重計時旬首 **/
      //　時旬首
      var chun_sau =
        '子丑寅卯辰巳午未申酉戌亥'.indexOf(dcol0[0]) -
        '甲乙丙丁戊己庚辛壬癸'.indexOf(tcol0[0])
      // console.log('chun_sau',chun_sau)
      if (chun_sau < 0) chun_sau += 12
      // 建地盤
      var dei_pan = '' // 建地盤
      if (dun_type == 1) {
        // 陽遁
        // var dei_pan = " 戊己庚辛壬癸丁丙乙戊己庚辛壬癸丁丙乙".substr(9-using_kook+1,9); // 地盤
        var dei_pan = '戊己庚辛壬癸丁丙乙戊己庚辛壬癸丁丙乙'.substr(
          9 - using_kook + 1,
          9
        ) // 地盤
      } else {
        // 陰遁
        // var dei_pan = " 戊乙丙丁癸壬辛庚己戊乙丙丁癸壬辛庚己".substr(9-using_kook+1,9);
        var dei_pan = '戊乙丙丁癸壬辛庚己戊乙丙丁癸壬辛庚己'.substr(
          9 - using_kook + 1,
          9
        )
      } // console.log(dei_pan);
      // 找值符
      var chun_sau = ' 子戌申午辰寅'.indexOf(
        '子寅辰午申戌'.charAt(parseInt(chun_sau / 2))
      )
      var jik_fu_idx = 0
      var jik_fu_star = 0
      var _tmp = tcol0[0]
      if (dun_type == 1) {
        // 陽遁
        var jik_fu_idx = using_kook + chun_sau - 1
        while (jik_fu_idx > 9) jik_fu_idx -= 9
        while (jik_fu_idx < 1) jik_fu_idx += 9
        if (_tmp == '甲') _tmp = ' 戊己庚辛壬癸'.charAt(chun_sau)
        // console.log(_tmp,parseInt(chun_sau/2),chun_sau/2,chun_sau);
        jik_fu_star = ' 戊己庚辛壬癸丁丙乙'.indexOf(_tmp) + using_kook - 1
        while (jik_fu_star > 9) jik_fu_star -= 9
      } else {
        var jik_fu_idx = 1 + using_kook - chun_sau
        while (jik_fu_idx > 9) jik_fu_idx -= 9
        while (jik_fu_idx < 1) jik_fu_idx += 9
        // console.log(chun_sau);
        if (_tmp == '甲') _tmp = ' 戊己庚辛壬癸'.charAt(chun_sau)
        jik_fu_star = 1 + using_kook - ' 戊己庚辛壬癸丁丙乙'.indexOf(_tmp)
        // console.log(" 戊己庚辛壬癸丁丙乙".indexOf(_tmp));
        while (jik_fu_star < 1) jik_fu_star += 9
      }
      // console.log(jik_fu_idx,jik_fu_star)
      // if(jik_fu_star == 5) jik_fu_star = 2; // 禽星寄二宮
      str = `值符天${'，蓬芮冲辅禽心柱任英'.charAt(
        jik_fu_idx
      )}落${',一二三四五六七八九'.charAt(jik_fu_star)}宮`
      this.qimenVar.zhifustr = str

      if (jik_fu_star == 5) jik_fu_star = 2 // 禽星寄二宮
      // 計值使, 不分陰陽遁
      var jik_fu_mun = 0
      if (dun_type == 1) {
        jik_fu_mun = jik_fu_idx + ' 甲乙丙丁戊己庚辛壬癸'.indexOf(tcol0[0]) - 1
        while (jik_fu_mun > 9) jik_fu_mun -= 9
      } else {
        jik_fu_mun = jik_fu_idx - ' 甲乙丙丁戊己庚辛壬癸'.indexOf(tcol0[0]) + 1
        while (jik_fu_mun < 1) jik_fu_mun += 9
      }
      // console.log("jik_fu_mun:",jik_fu_mun);
      if (jik_fu_mun == 5) jik_fu_mun = 2 // 中宮寄坤二宮
      str = `值使${' 休死傷杜中開驚生景'.charAt(
        jik_fu_idx
      )}门落${',一二三四五六七八九'.charAt(jik_fu_mun)}宫`
      this.qimenVar.zhishistr = str

      // 輸出柱名
      str = '　　'
      for (var i = 0; i < jiqi.bazi.length; i += 2) {
        str += '　' + '　年　月　日　时　分'.substr(i, 2)
      }
      outstr.push(str)
      // console.log(jiqi.bazi)
      // 輸出八字
      str = ''
      for (var i = 0; i < jiqi.bazi.length - 10; i += 2) { str += '　' + jiqi.bazi.substr(i, 2) }
      outstr.push(str)

      // 計空亡
      var _hung_mon = new Array()
      str = ''
      for (var i = 0; i < jiqi.bazi.length - 10; i += 2) {
        var chun_sau =
          '子丑寅卯辰巳午未申酉戌亥'.indexOf(jiqi.bazi[i + 1]) -
          '甲乙丙丁戊己庚辛壬癸'.indexOf(jiqi.bazi[i])
        if (chun_sau < 0) chun_sau += 12
        var hung_mon = chun_sau - 2
        if (hung_mon < 0) hung_mon += 12
        str += '　' + '子丑寅卯辰巳午未申酉戌亥'.substr(hung_mon, 2)
        _hung_mon.push(hung_mon)
      }
      outstr.push(str)

      // ---
      // 計算時家奇門遁甲
      // ---
      let q1 = QIMEN.qimenCalc(dun_type, using_kook, jiqi.bazi.substr(6, 2))
      let q2 = QIMEN.minQimen(solarHourValue, solarMnuteValue, 0)
      this.qimenVar.zhifu = `天${q1['info']['符']}`

      let diPanTianGan = {}
      let tianPanTianGan = {}

      let bashen = {}
      let bamen = {}
      let jiuxing = {}
      let leftTianGan = {}
      let kongWang = {}
      let gn = {
        符: '值符',
        蛇: '螣蛇',
        阴: '太阴',
        合: '六合',
        白: '白虎',
        玄: '玄武',
        地: '九地',
        天: '九天'
      }
      // console.log(555,q1['神'],gn[q1['神']])
      for (var i = 0; i < 9; i++) {
        if (i != 4) {
          // 八神
          bashen[i + 1] = gn[q1['神'][i + 1]]
          // 八门
          bamen[i + 1] = q1['门'][i + 1] + '门'
          // 九星
          jiuxing[i + 1] = '天' + q1['星'][i + 1]
          // 天盘天干
          tianPanTianGan[i + 1] = q1['天'][i + 1]
        }
        if (q1['星'][i + 1] == '芮') {
          leftTianGan[i + 1] = q1['天'][5]
        }
        // 地盘天干
        diPanTianGan[i + 1] = q1['地'][i + 1]

        // 時家奇門空亡
        var a = '077233811655'.charAt(_hung_mon[3])
        kongWang[Number(a) + 1] = 'Ｏ'

        var a = '077233811655'.charAt(_hung_mon[3] + 1)
        kongWang[Number(a) + 1] = 'Ｏ'
      }

      // console.log(bamen);
      this.qimenVar.outstr = outstr
      this.qimenVar.diPanTianGan = diPanTianGan
      this.qimenVar.tianPanTianGan = tianPanTianGan
      this.qimenVar.leftTianGan = leftTianGan
      this.qimenVar.bashen = bashen
      this.qimenVar.bamen = bamen
      this.qimenVar.jiuxing = jiuxing
      this.qimenVar.kongWang = kongWang
      // console.log(this.qimenVar);
    }
  },
  computed: {
    baziGender () {
      if (this.formItem.gender == 1) {
        return '乾造：'
      }
      if (this.formItem.gender == 2) {
        return '坤造：'
      }
      return ''
    }
  },
  watch: {}
}
</script>
<style lang="less" scoped>
.preview {
  height: inherit;
  position: relative;
  overflow: hidden;
}

.preview-area {
  overflow: auto;
  position: relative;
  height: inherit;
  z-index: 0;
  display: flex;
}

// 头部
.preview-head {
  width: 100%;
  top: 0;
  z-index: 2;

  .bar {
    // background-color: @grey100;
  }

  .content {
    height: 0;
    overflow: auto;
    transition: all 0.2s;
    padding-top: 0;
    padding-bottom: 0;
    margin-top: 0;
    margin-bottom: 0;
    // background-color: @grey50;
    user-select: text;

    code {
      background: none;
      font-family: Consolas, Liberation Mono, Menlo, Courier, monospace;
    }
  }

  .content.active {
    height: 95vh;
  }
}

.preview-left,
.preview-right {
  width: 42%;
  height: 100%;
  padding: 0 20px 20px 20px;
}

.preview-right {
  flex: 1;
}

.preview-left {
  // background: red;
  width: 45%;
  &-progress {
    padding: 0.5vw 0.6vw;
    height: 1vw;
  }
}

.preview-left-top {
  margin: 10px;
  left: 20px;
}

.preview-left-bottom {
  // width: calc("100% - 10px");
  display: flex;
  flex-wrap: wrap;
  margin-left: 10px;
}

.preview-left-row {
  width: 32%;
  height: 11vw;
  border: 10px solid #ccc;
  position: relative;
  margin: 0.5%;
}

.preview-left-ul {
  display: flex;
  flex-wrap: wrap;
  overflow-y: auto;
  width: 100%;
}

.preview-left-li {
  margin-left: 0.5vw;
  font-size: 0.9vw;
  list-style: none;
}

.preview-year {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);

  > li {
    border-radius: 50%;
    background: rgba(255, 60, 0, 0.7);
    width: 3vw;
    height: 3vw;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    display: none;
    font-size: 0.3vw;
  }

  .active {
    // display: block;
    display: flex;
  }
}

// 右边
.preview-right {
  &-bottom {
  }

  &-frame {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
  }

  &-row {
    width: 33%;
    // height: 12vw;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  &-row:nth-child(2) {
    margin: 0 0.5%;
  }

  &-col {
    width: 100%;
    border: 10px solid #ccc;
    height: 11vw;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    &.active {
      border-color: orange;
      border-style: double;
    }
  }

  &-line {
    height: 1vw;
    // background: red;
    width: 128px;
    height: 128px;
    margin: 1vw 0;
    background-size: 100% 100%;
    background-image: url("./image/pillar.png");
  }

  &-ul {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
  }

  &-ball {
    width: 2.3vw;
    height: 2.3vw;
    background: red;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    font-weight: bold;
  }
}

.amap-demo {
  height: 300px;
}

.new {
  padding-right: 10px;
  padding-left: 10px;
  font-size: 14px;
  padding-bottom: 5px;
  line-height: 22px;
  padding-top: 5px;
}

.demo-split {
  height: 100vh;
  border: 1px solid #dcdee2;
}

.demo-split-pane {
  padding: 10px;
}

.result-ball {
  display: flex;
  font-size: 25px;
  font-weight: bold;

  div {
    flex: 1;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
  }
}

.result-ball-pillar {
  width: 48px;
  height: 48px;
  margin: 0.2vw 0;
}

.bazitable {
  margin: 2px;
  clear: both;
  display: block;
  border-collapse: collapse;
  empty-cells: show;
  border: 0;
  overflow: scroll;

  td {
    padding: 4px;
    text-align: center;
    white-space: nowrap;
    font-size: 16px;
  }

  td.left {
    text-align: left;
  }

  td.small {
    font-size: 16px;
  }

  td.bazi {
    font-size: 22px;
    font-weight: bold;
  }
}

.red {
  color: #c40000;
}

td.active {
  background: orange;
  color: #000;
}

.birth_time,
.now_time {
  align-items: center;
  display: flex;
  margin-bottom: 10px;
}

.birth_time_name,
.now_time_name {
  margin-right: 10px;
}

.birth_time_roll,
.now_time_roll {
  width: 2.3vw;
  height: 2.3vw;
  background: red;
  border-radius: 50%;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-align: center;
  align-items: center;
  -ms-flex-pack: center;
  justify-content: center;
  color: #fff;
  font-weight: bold;
  margin-right: 5px;
}

.now_time_roll {
  background-color: #2c8cf1;
}

.color-blue {
  color: blue;
}

.color-red {
  color: red;
}

.r-center {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  // font-weight: bold;
  font-size: 17px;
  color: #000;
  line-height: 200%;
  // color: rgb(255, 0, 0);
}
</style>
